<template>
  <div>
    <div style="width: 100%;height:100vh;position: relative;background: #F0F3F6;" id="homePage" ref="scrollview">
      <happy-scroll color="#3C7CFF" size="5" hide-horizontal resize>
        <div id="homePage" style="width:100vw;">
          <div class="qdTop">
            <div style="position: absolute;top:0;left: 0;width: 100%;">
              <Menu ref="selectHide" v-if="menuShow"></Menu>
            </div>
          </div>
          <div class="qdMiddlew">
            <div class="qdMiddle">
              <div class="qdMiddle1">
                <div style="display: flex;justify-content: space-between;margin-top: 0.15rem;margin-bottom: 0.1125rem;"
                  class="qzxwSty">
                  <div style="font-size: 0.3rem;font-weight: bold;color: #333333;">新闻资讯</div>
                  <div>
                    <el-button icon="el-icon-arrow-right" @click="toMoreList"></el-button>
                  </div>
                </div>
                <div
                  style="display: flex;width: 100%;flex-wrap:wrap;justify-content: space-between;padding-right: 0.7625rem;box-sizing: border-box;">
                  <div v-for="(item,index) in infoList" :key="index" style="width: 8.25rem;cursor: pointer;"
                    @click="toMoreInfo(item)">
                    <div
                      :style="{'display':'flex','align-items':'center','width':'8.25rem','height': '0.675rem','line-height': '0.675rem','border-bottom': (index!=4&&index!=5)?'0.0125rem dashed #BFBFBF':''}">
                      <img src="./image/rd.png" style="width: 0.2375rem;height: 0.275rem;margin-right: 0.0875rem;"
                        v-if="index==0||index==1">
                      <div
                        :style="{width:(index==0||index==1)?'7.925rem':'8.25rem',overflow: 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap','font-size':'0.2rem'}">
                        {{item.title}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
<!--              <div class="qdMiddle2" style="justify-content: flex-end;">
                <div class="qdMiddle21" :class="{qdMiddle21Active:(index==activeYy)}" v-for="(item,index) in appoint"
                  :key="index" style="cursor: pointer;" @click="toClickYy1(index)" @mouseenter="toEnterYy1(index)"
                  @mouseleave="toLeaveYy1(index)">
                  <div style="text-align:center;margin-top: 0.4375rem;margin-bottom: 0.2875rem;
font-size: 0.25rem;
font-family: Microsoft YaHei;
font-weight: bold;
color: #333333;" class="txt1">{{item.name}}</div>
                  <div class="txt2" style="text-align:center;
font-size: 0.2rem;
font-family: Microsoft YaHei;
font-weight: 400;
color: #555555;">{{item.desc}}</div>
                  <div class="txt2" style="text-align:center;margin-top: 0.05rem;
font-size: 0.2rem;
font-family: Microsoft YaHei;
font-weight: 400;
color: #555555;">{{item.desc1}}</div>
                  <div style="width: 100%;margin: 0.6rem auto 0 auto;text-align: center;" class="img3div">
                    <img :src="item.img" style="width: 1.1875rem;height: 1.05rem;margin: 0 auto;" class="img3">
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div style="width: 100%;margin-top: 1.2875rem;">
            <img src="./image/kjgk.png" style="width: 1.7375rem;height: 0.3375rem;margin: 0 auto;display:block" />
            <img src="./image/kjgkyw.png"
              style="width: 1.525rem;height: 0.1375rem;margin: 0.1375rem auto 0.5875rem auto;display:block" />
            <div class="kjggkSty" style="display:flex;flex: 0 0 7.5875rem;box-sizing: border-box;">
              <img :src="picture" style="width: 7.5875rem;height: 4.025rem;">
              <div style="flex: 1;padding-left: 1.1625rem;box-sizing: border-box;">
                <div style="display: flex;justify-content: space-between;">
                  <div style="flex: 0 0 7.2rem;font-size: 0.25rem;color: #555555;line-height: 0.5rem;height: 4.025rem;text-indent:2em;
                display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;
                " v-html="introduction">

                  </div>
                  <img src="./image/about.png"
                    style="flex: 0 0 2.3125rem;width: 2.3125rem;height: 1.35rem;margin-top: 0.16rem;" />
                </div>
                <div style="display: flex;justify-content: flex-end; margin-top: -0.5rem;align-items: center;">
                  <!-- <div style="flex: 1;">
                    <div style="font-size: 0.3rem;font-weight: 800;color: #2498FC;">2022</div>
                    <div style="font-size: 0.2rem;color: #999999;">成立时间/年</div>
                  </div>
                  <div style="flex: 1;">
                    <div style="font-size: 0.3rem;font-weight: 800;color: #2498FC;">16万</div>
                    <div style="font-size: 0.2rem;color: #999999;">建筑面积/平方米</div>
                  </div>
                  <div style="flex: 1;">
                    <div style="font-size: 0.3rem;font-weight: 800;color: #2498FC;">239</div>
                    <div style="font-size: 0.2rem;color: #999999;">馆藏设施/套</div>
                  </div> -->
                  <div style="display: flex;flex-direction: row;height: 0.475rem;line-height: 0.475rem;cursor: pointer;"
                    @click="toOverview">
                    <div style="font-size: 0.225rem;color: #999999;margin-right: 0.225rem;">查看全部</div>
                    <div>
                      <el-button icon="el-icon-arrow-right"></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 100%;margin-top: 2.0375rem;position: relative;">
            <img src="./image/zltj.png" style="width: 1.375rem;height: 0.3375rem;margin: 0 auto;display:block" />
            <img src="./image/zltjyw.png"
              style="width: 2.3rem;height: 0.1625rem;margin: 0.1375rem auto 0.5875rem auto;display:block" />
            <div
              style="width: 16.1125rem;flex-direction: column;margin: 0 auto;position:relative;margin-bottom: 3.1875rem">
              <img src="./image/zltj1.png"
                style="width: 2.7875rem;height: 2.8rem;position:absolute;left:-2.7rem;top: -1.8625rem;">
              <img src="./image/zltj2.png"
                style="width: 2.575rem;height: 2.5125rem;position:absolute;bottom:-2.6375rem;left: -2.575rem;">
              <img src="./image/zltj3.png"
                style="width: 3.775rem;height: 2.35rem;position:absolute;right: -1.9875rem;bottom: -1.3625rem;">
              <div
                style="cursor:pointer;display: flex;width: 16.1125rem;justify-content: space-between;margin-bottom: 0.7375rem;position:relative"
                v-for="(item,index) in commonList" :key="index" @click="toRecommend(item.id)">
                <div style="flex: 0 0 4.875rem;position: relative;margin-top: 0.1125rem;">
                  <div style="width: 4.875rem;
height: 2.5375rem;
background: #2498FC;
border-radius: 0.075rem;position:absolute;top:0;left:0;"></div>
                  <img v-lazy="item.mainImage"
                    style="width: 4.875rem;height: 2.55rem;position:absolute;top:-0.125rem;left:-0.125rem;border-radius: 0.075rem;" />
                </div>
                <div style="flex:0 0 11.125rem;width: 11.125rem;padding:0.3625rem 0.4375rem;box-sizing: border-box;height: 2.65rem;
font-size: 0.2rem;
color: #FFFFFF;
line-height: 0.4rem;
background: #2498FC;
border-radius: 0.075rem;">
                  <div>{{item.name}}：</div>
                  <div style="display: -webkit-box;height:1.6rem;
                    -webkit-line-clamp:4;-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;">
                    {{item.originalIntention}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wholeSwiper" style="width: 100%;height: 7.375rem;background: #F0F3F6;position:relative">
            <img src="./image/jybjs.png" style="position:absolute;top:0;left:0;width: 100%;height: 7.375rem;">
            <div style="position:absolute;top:0;left:0;width: 100%;height: 7.375rem;box-sizing:border-box">
              <div style="width: 18.025rem;margin:0 auto">
                <div style="display: flex;justify-content:center;width:100%;margin-bottom: 0.1375rem;"><img
                    src="./image/jyhd.png" style="width:1.3875rem;height:0.3375rem;"></div>
                <div style="display: flex;justify-content:center;width:100%;margin-bottom: 0.8125rem;"><img
                    src="./image/jyhdyw.png" style="width:1.7375rem;height:0.1375rem;"></div>
                <div style="width: 100%;height:3.75rem">
                  <div style="width: 18.025rem;height:100%;position:relative">
                    <div class="swiper-container" style="width: 15rem;margin:0 auto">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide edu-slide" v-for="(item,index) in activityList" :key="index"
                          style="display: flex;cursor: pointer;" @click="toMoreInfo1(item)">
                          <div style="flex:0 0 6rem"><img v-lazy="item.mainImg"
                              style="cursor: pointer;width:6rem;height:3.75rem" /></div>
                          <div style="flex: 0 0 9rem;width:9rem;padding:0 0.8875rem;box-sizing:border-box">
                            <div
                              style="margin-top: 0.775rem;margin-bottom: 0.3625rem;white-space:nowrap;overflow: hidden;text-overflow:ellipsis;font-size: 0.275rem;font-family: Microsoft YaHei;font-weight: bold;color: #333333;">
                              {{item.name}}
                            </div>
                            <div style="display: -webkit-box;font-size: 0.225rem;line-height: 0.375rem;height:1.125rem;-webkit-line-clamp:3;-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;text-indent:2em;white-space: pre-wrap;">{{item.synopsis}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-button-next swiper-button-next2"></div>
                    <div class="swiper-button-prev swiper-button-prev2"></div>
                    <div class="swiper-pagination"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wrap" style="height: auto;position: relative;padding-top: 100vh;
}">
            <!-- <div> -->
            <div v-if="activeClass" :class="{'bg-img':true,isFixed:(activeClass)}"
              :style="{'background-size':sizeComputed}">
            </div>
            <div v-else :class="{'bg-img':true,'bg-img1':downto}" :style="{'background-size':sizeComputed}"></div>
            <!-- </div> -->
            <div class='scrollContent1' @scroll="toScroll">
              <div v-for="(item,index) in cinemaList" :key="index">
                <div class='scrollContent11'> {{item.hallName}} </div>
                <div class='scrollContent12' style="white-space: pre-wrap;display: -webkit-box;
                    -webkit-line-clamp:4;-webkit-box-orient: vertical;text-overflow: ellipsis;overflow: hidden;">
                  {{item.note}}
                </div>
              </div>

              <div class='scrollContent15' style="display: flex;flex-direction:row">
                <div v-for="(item,index) in filmList" class='scrollContent151'>
                  <img v-lazy="item.posterImg" class='scrollContent152'>
                  <div class='scrollContent153'>{{item.filmName}}</div>
                </div>
              </div>
              <div class='scrollContent16' ref="scrollContent16" @click="toCinema">
                <el-button>更多影片</el-button>
              </div>
            </div>
          </div>

          <div
            style=";width: 19.5rem;height:3.25rem;z-index: 3000;position:relative;margin:1.375rem auto 1.375rem auto;box-sizing:border-box;display:flex;justify-content:space-around;">
            <div style="flex:0 0 6.25rem"><img src="./image/hys.png" @click="toMember"
                style="width:6.25rem;height:3.25rem;cursor:pointer"></div>
            <div style="flex:0 0 6.25rem"><img src="./image/zyzs.png" @click="toVolunteer"
                style="width:6.25rem;height:3.25rem;cursor:pointer"></div>
            <div style="flex:0 0 6.25rem"><a href="https://720a.cn/p/97738307" target="_blank" style="display:inline-block;width:6.25rem;height:3.25rem;"><img src="./image/xngs.png" style="width:6.25rem;height:3.25rem;"></a></div>
<!--            <div style="flex:0 0 6.25rem"><img src="./image/xngs.png" @click="toFullScreen"
                style="width:6.25rem;height:3.25rem;"></div> -->
          </div>
          <Footer></Footer>
        </div>
      </happy-scroll>
    </div>
    <el-dialog class="selfDiaguis" title="个人预约" :visible.sync="centerDialogVisible" :close-on-click-modal="false"
      width="30%" center>
      <div style="height: 6.95rem;">
        <happy-scroll color="#c2c1bf" size="5" resize>
          <div class="teamSty">
            <div class="teamTitle1">预约须知：</div>
            <div class="teamTitle1">一、开放时间</div>
            <div class="teamContent" v-html="dataInfo.openContent" style="white-space: pre-wrap;"></div>
            <div class="teamTitle1">二、参观预约</div>
            <div class="teamContent" v-html="dataInfo.appointmentContent" style="white-space: pre-wrap;"></div>
            <div class="teamTitle1">三、其他事项</div>
            <div class="teamContent" v-html="dataInfo.content" style="white-space: pre-wrap;"></div>
          </div>
        </happy-scroll>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="cancelBut" @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button class="nextBut" type="primary" @click="toConfirm">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog class="selfDiaguis selfDiaguis1" title="个人预约" :visible.sync="centerDialogVisible1"
      :close-on-click-modal="false" width="30%" center>
      <div style="height: 6.95rem;">
        <div id="consultpage1"
          style="height: auto;padding: 0rem 0rem 1.25rem 0rem;margin:0 auto;box-sizing: border-box;">
          <div style="width: 100%;display: flex;">
            <div style="flex: 0 0 4.15rem;">
              <img src="./image/selfAppoint.png" style="width: 4.15rem;height: 5.55rem;">
            </div>
            <div style="flex: 1;padding-left: 0.625rem;box-sizing: border-box;">
              <div style="display: flex;align-items: center;">
                <span class="appointTitle">青岛科技馆参观预约</span>
              </div>
              <div style="height: 5rem;">
                <happy-scroll color="#c2c1bf" size="5" hide-horizontal resize>
                  <div>
                    <div style="text-align:left;margin-top: 0.475rem;margin-bottom: 0.325rem;"><span
                        style="font-size: 0.25rem;font-weight: bold;color: #333333;">参观日期</span><span
                        style="font-size: 0.25rem;color: #333333;" v-if="time">(剩余票数：{{remainingTicket}})</span></div>
                    <div style="display: flex;flex-wrap: wrap;">
                      <div v-for="(item,index) in dateList" :key="index" @click="dateSelect(item,index)"
                        class="dateStyw" style="cursor:pointer;position: relative;">
                        <img src="./image/selectedpng.png" v-if="index==dateActive"
                          style="position:absolute;top:0;left:0;width: 2.4375rem;height: 1.325rem;" />
                        <div class="dateSty"
                          :style="{background:(item.disabled)?'rgba(229, 229, 229, 1)':'',color:(item.disabled)?'#BFBFBF':''}">
                          <div class="dateSty1">{{item.date}}</div>
                          <div class="dateSty1">{{item.dayOfWeek}}</div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 0.225rem;margin-bottom: 0.325rem;text-align:left"><span
                        style="font-size: 0.25rem;font-weight: bold;color: #333333;;">参观时段</span></div>
                    <div class="timeSty">
                      <div :class="{timeSty1:true,timeActive:(timeActive==index)}"
                        :style="{background:(!item.show)?'rgba(229, 229, 229, 1)':'',color:(!item.show)?'#BFBFBF':''}"
                        @click="timeSelect(item,index)" v-for="(item,index) in timeList" :key="index">{{item.during}}
                      </div>
                    </div>
                  </div>
                </happy-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="cancelBut" @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button class="nextBut" type="primary" @click="toConfirm1">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog class="selfDiaguis2" title="个人预约" :visible.sync="centerDialogVisible2" :close-on-click-modal="false"
      width="30%" center>
      <div style="height: 6.95rem;">
        <div style="margin:0 auto;height: auto;;box-sizing: border-box;">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <div style="display: flex;">
              <div style="flex: 1;">
                <div class="selfBut" style="text-align:left">
                  <el-button style="margin-bottom: 0.725rem;">个人预约</el-button>
                  <el-form-item label="姓名" prop="realName" :style="{'margin-bottom': '0.5875rem'}">
                    <el-input v-model="ruleForm.realName" placeholder="请输入真实姓名" maxlength="5"></el-input>
                  </el-form-item>
                  <el-form-item label="证件类型" prop="idcardType" :style="{'margin-bottom': '0.5875rem'}">
                    <el-select v-model="ruleForm.idcardType" placeholder="请选择证件类型" @change="changeCard">
                      <el-option :label="item.label" :value="item.value" v-for="(item,index) in cardType"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="证件号码" required prop="idNum" :rules="idNum" :style="{'margin-bottom': '0.5875rem'}" v-if="ruleForm.idcardType==10">
                    <el-input v-model="ruleForm.idNum" placeholder="请输入证件号码"></el-input>
                  </el-form-item>
                  <el-form-item label="证件号码" required prop="idNum" :rules="idNum1" :style="{'margin-bottom': '0.5875rem'}" v-if="ruleForm.idcardType==20">
                    <el-input v-model="ruleForm.idNum" placeholder="请输入证件号码"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号码" prop="phoneNum" :style="{'margin-bottom': '0.5875rem'}">
                    <el-input v-model="ruleForm.phoneNum" placeholder="请输入手机号码"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div style="flex: 1;" class="selfBut">
                <div style="display: flex;">
                  <div style="flex: 1;text-align:left">
                    <span style="font-size: 0.3rem;font-weight: bold;color: #333333;text-align:left">随行人员</span>
                  </div>
                  <div style="flex: 0 0 1.25rem;" class="addSty">
                    <el-button icon="el-icon-circle-plus-outline" @click="addPerson">添加</el-button>
                  </div>
                </div>
                <div style="text-align:left;margin-bottom:0.375rem">
                  <span style="font-size: 0.22rem;color: #333333;">可携带随行人员，如无必要可不必填写</span>
                </div>
                <div style="height: 6rem;">
                  <happy-scroll color="#c2c1bf" size="5" hide-horizontal resize>
                    <div class="sxrySty">
                      <div v-for="(item,index) in personList" :key="index">
                        <el-form :model="item" :rules="rules1" ref="ruleForm1" label-width="200px"
                          class="demo-ruleForm">
                          <div style="position: relative;width: 100%;">
                            <el-form-item label="姓名" prop="realName">
                              <el-input v-model="item.realName" placeholder="请输入真实姓名" maxlength="5"></el-input>
                            </el-form-item>
                            <div @click="delPerson(index)"
                              style="cursor:pointer;position: absolute;left:6rem;top: 0;height: 0.925rem;line-height: 0.925rem;font-size: 0.275rem;color: #3C7CFF;">
                              删除</div>
                          </div>
                          <el-form-item label="证件类型" prop="idcardType">
                            <el-select v-model="item.idcardType" placeholder="请选择证件类型" @change="changeCard1(index)">
                              <el-option :label="item.label" :value="item.value" v-for="(item,index) in cardType"
                                :key="index"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="证件号码" required prop="idNum" :rules="idNum" v-if="item.idcardType==10">
                            <el-input v-model="item.idNum" placeholder="请输入证件号码"></el-input>
                          </el-form-item>
                          <el-form-item label="证件号码" required prop="idNum" :rules="idNum1" v-if="item.idcardType==20">
                            <el-input v-model="item.idNum" placeholder="请输入证件号码"></el-input>
                          </el-form-item>
                          <el-form-item label="年龄" prop="age" @mouseenter.native="mouseenterage(index)"
                            @mouseleave.native="mouseleaveage(index)">

                            <span role="button" class="el-input-number__increase1" @mousedown="toIncreaseage(index)"
                              v-if="(focus2[index]==1)||(focus3[index]==1)">
                              <i class="el-icon-arrow-up"></i>
                            </span>
                            <span role="button" class="el-input-number__decrease1" @mousedown="toDecreaseage(index)"
                              v-if="(focus2[index]==1)||(focus3[index]==1)">
                              <i class="el-icon-arrow-down"></i>
                            </span>
                            <el-input-number v-model="item.age" ref="refNumber1age"
                              @input.native="eventDisposalRangeChangeage()" controls-position="right"
                              placeholder="请输入年龄" @blur="focus2[index]=0" @focus="focus2[index]=1" :min="1">
                            </el-input-number>
                          </el-form-item>
                          <el-form-item label="学校" prop="school" :style="{'margin-bottom': '0.5875rem'}">
                            <el-input v-model="item.school" placeholder="请输入学校" maxlength="20"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </happy-scroll>
                </div>

              </div>
            </div>
            <el-form-item style="text-align: center;" class="butselfSty">
              <el-button @click="toCancel" class="prevStep">上一步</el-button>
              <el-button type="primary" @click="submitFormu('ruleForm')" class="submitStep">提交</el-button>

            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button class="nextBut" type="primary" @click="toConfirm">下一步</el-button>
    </span> -->
    </el-dialog>
    <el-dialog class="selfDiag" title="本人承诺" :visible.sync="centerDialogVisible3" width="30%" center>
      <div style="text-align: left;font-size: 0.275rem;color: #333333;line-height: 0.55rem;">
        一、本人及随行人员参观科技馆前7天内：无发热、咳嗽、发力等症状；无国内中高风险地区旅居史；没有接触新冠肺炎确诊病例、无症状感染者或密切接触者<br>
        二、本人及随行人员10天内无境外旅居史；<br>
        三、本人及随行人员不是仍处于康复或隔离期的病例无症状感染者或密接者。<br>
      </div>
      <div
        style="margin-top: 0.25rem;text-align: left;font-size: 0.275rem;font-weight: bold;color: #333333;line-height: 0.55rem;">
        以上内容属实，如隐瞒、虚报、谎报，本人承担一切法律责任和相应后果。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelBut" @click="cancelSelf">取 消</el-button>
        <el-button class="confirmBut" type="primary" @click="sendCapture">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="yzmDiag" title="请输入验证码" :visible.sync="yzmDiag" width="30%" center>
      <div style="display: flex;align-items: center;justify-content: center;">
        <img v-lazy="captcha" style="flex: 0 0 2.05rem;height: 0.5125rem;margin-right: 0.1625rem;" />
        <span style="font-size: 0.2625rem;color: #EE564F;cursor: pointer;" @click="getCaptchaCache">刷新</span>
      </div>
      <div style="margin-top: 0.5rem;">
        <el-input v-model="captchaNum" placeholder="请输入验证码"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelBut" @click="cancelSelf1">取 消</el-button>
        <el-button class="confirmBut" :disabled="disabledSelf" type="primary" @click="toselfAppoint">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="selfDiaguis2" title="个人预约" :visible.sync="centerDialogVisible6" width="30%" center>
      <div id="consultpage1">
        <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;">
          <img src="./image/selfFinish.png" style="width: 4.1125rem;height: 3.8625rem;margin-top: 1.65rem;">
        </div>
        <div style="width:100%;text-align:center;font-size: 0.3rem;color: #333333;">预约已提交成功，详情请前往<span
            style="cursor:pointer;color: #3C7CFF;">&nbsp;我的预约&nbsp;</span>中查看</div>
        <div style="text-align: center;">
          <el-button class="prevStep" style="margin-top: 0.75rem;" @click='toCancelAppoint'>取消</el-button>
          <el-button type="primary" class="submitStep" style="margin-top: 0.75rem;" @click="toPerson">查看</el-button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button class="cancelBut" @click="centerDialogVisible6 = false">取 消</el-button>
      <el-button class="confirmBut" type="primary" @click="sendCapture">确 定</el-button>
    </span> -->
    </el-dialog>
    <el-dialog class="selfDiaguis2" title="个人预约" :visible.sync="centerDialogVisible7" width="30%" center>
      <div id="consultpage1">
        <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;">
          <img src="./image/selfFinish.png" style="width: 4.1125rem;height: 3.8625rem;">
        </div>
        <div style="width:100%;text-align:center;font-size: 0.3rem;color: #333333;"> 门票已预约完成，核销后方可继续预约热门展项。</div>
        <div style="text-align: center;">
          <!-- <el-button class="prevStep" style="margin-top: 0.75rem;" @click='toCancelAppoint'>取消</el-button> -->
          <el-button type="primary" class="submitStep" style="margin-top: 1.75rem;" @click="toInfoRm">确定</el-button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button class="cancelBut" @click="centerDialogVisible6 = false">取 消</el-button>
      <el-button class="confirmBut" type="primary" @click="sendCapture">确 定</el-button>
    </span> -->
    </el-dialog>

    <el-dialog class="selfDiaguis" title="团队预约" :visible.sync="centerDialogVisibletd" :close-on-click-modal="false"
      width="30%" center>
      <div style="height: 6.95rem;">
        <happy-scroll color="#c2c1bf" size="5" resize>
          <div class="teamSty">
            <div class="teamTitle1">预约须知：</div>
            <div class="teamTitle1">一、开放时间</div>
            <div class="teamContent" v-html="dataInfo.openContent" style="white-space: pre-wrap;"></div>
            <div class="teamTitle1">二、参观预约</div>
            <div class="teamContent" v-html="dataInfo.appointmentContent" style="white-space: pre-wrap;"></div>
            <div class="teamTitle1">三、其他事项</div>
            <div class="teamContent" v-html="dataInfo.content" style="white-space: pre-wrap;"></div>
          </div>
        </happy-scroll>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="cancelBut" @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button class="nextBut" type="primary" @click="toConfirmtd">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog class="selfDiaguis selfDiaguis1 selfDiaguis1t" title="团队预约" :visible.sync="centerDialogVisibletd1"
      :close-on-click-modal="false" width="30%" center>
      <div style="height: 7.95rem;">
        <div id="consultpage1"
          style="height: auto;padding: 0.7875rem 0rem 1.25rem 0rem;margin:0 auto;box-sizing: border-box;">
          <div style="width: 100%;display: flex;">
            <div style="flex: 0 0 4.15rem;">
              <img src="./image/selfAppoint.png" style="width: 4.15rem;height: 5.55rem;">
            </div>
            <div style="flex: 1;padding-left: 0.625rem;box-sizing: border-box;width:calc(100%)">
              <div style="display: flex;align-items: center;">
                <span class="appointTitle">青岛科技馆参观预约</span>
              </div>
              <div style="height: 6rem;">
                <happy-scroll color="#c2c1bf" size="5" hide-horizontal resize>
                  <div>
                    <div style="margin-top: 0.475rem;margin-bottom: 0.325rem;;text-align:left"><span
                        style="font-size: 0.25rem;font-weight: bold;color: #333333;text-align:center">参观日期</span><span
                        style="font-size: 0.25rem;color: #333333;" v-if="timetd"></span></div>
                    <div style="display: flex;flex-wrap: wrap;">
                      <div v-for="(item,index) in dateListtd" :key="index" @click="dateSelecttd(item,index)"
                        class="dateStyw" style="cursor:pointer;position: relative;">
                        <img src="./image/selectedpng.png" v-if="index==dateActivetd"
                          style="position:absolute;top:0;left:0;width: 2.4375rem;height: 1.325rem;" />
                        <div class="dateSty"
                          :style="{background:(item.disabled)?'rgba(229, 229, 229, 1)':'',color:(item.disabled)?'#BFBFBF':''}">
                          <div class="dateSty1">{{item.date}}</div>
                          <div class="dateSty1">{{item.dayOfWeek}}</div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-top: 0.225rem;margin-bottom: 0.325rem;;text-align:left"><span
                        style="font-size: 0.25rem;font-weight: bold;color: #333333;">开馆时间</span></div>
                    <div class="timeSty">
                      <div :class="{timeSty1:true,timeActive:(timeActivetd==index)}"
                        :style="{background:(!item.show)?'rgba(229, 229, 229, 1)':'',color:(!item.show)?'#BFBFBF':''}"
                        @click="timeSelecttd(item,index)" v-for="(item,index) in timeListtd" :key="index">
                        {{item.during}}
                      </div>
                    </div>
                    <div style="margin-top: 0.225rem;margin-bottom: 0.325rem;;text-align:left"><span
                        style="font-size: 0.25rem;font-weight: bold;color: #333333;">参观时间</span></div>
                    <div class="timeSty" style="display: flex;flex-direction: row;">
                      <div style="display:flex;flex: 1;align-items: center;text-align:left" class="tdtime">
                        <div style="flex:0 0 1.4rem;font-size: 0.25rem;">开始时间：</div>
                        <div style="flex: 1;">
                          <el-time-picker v-model="paramstd.startTime" class="date-box" format="HH:mm:ss"
                            value-format="HH:mm:ss" @change="change" :picker-options="{
                           selectableRange:`00:00:00 -${paramstd.endTime ? paramstd.endTime : '23:59:59'}`
                         }">
                          </el-time-picker>
                        </div>
                      </div>
                      <div style="display:flex;flex: 1;align-items: center;;text-align:left" class="tdtime">
                        <div style="flex:0 0 1.4rem;font-size: 0.25rem;">结束时间：</div>
                        <div style="flex: 1;">
                          <el-time-picker v-model="paramstd.endTime" format="HH:mm:ss" value-format="HH:mm:ss"
                            :picker-options="{
                             selectableRange: `${paramstd.startTime ? paramstd.startTime : '00:00:00'}-23:59:59`
                           }">
                          </el-time-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </happy-scroll>
              </div>
              <!-- <div class="nextBut">
              <el-button @click='toNext'>下一步</el-button>
            </div> -->
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="cancelBut" @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button class="nextBut" type="primary" @click="toConfirmtd1">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog class="tdAppoint" title="团队预约" :visible.sync="centerDialogVisibletd2" :close-on-click-modal="false"
      width="30%" center>
      <div style="">
        <div style="margin:0 auto;height: auto;;box-sizing: border-box;">
          <el-form :model="ruleFormtd" :rules="rulestd" ref="ruleFormtd" label-width="100px" class="demo-ruleForm">
            <div style="display: flex;">
              <div style="flex: 1;">
                <div class="selfBut selfBut2" style="text-align: left;">
                  <el-button style="margin-bottom: 0.625rem;margin-left: 0.575rem;">团队预约</el-button>
                  <el-form-item label="团队类型" prop="teamType">
                    <el-select v-model="ruleFormtd.teamType" placeholder="请选择团队类型" @change="changeTeamtd">
                      <el-option :label="item.label" :value="item.value" v-for="(item,index) in optionListtd"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :error="errorxxMsgtd" v-if="ruleFormtd.teamType===0">
                    <el-select v-model="ruleFormtd.schoolType" placeholder="请选择学校团队类型">
                      <el-option :label="item.label" :value="item.value" v-for="(item,index) in schoolOptionListtd"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="团队名称" prop="teamName">
                    <el-input v-model="ruleFormtd.teamName" placeholder="请输入团队名称（非个人名称）" maxlength="20"></el-input>
                  </el-form-item>
                  <el-form-item label="团队人数" prop="totalNum" style="width:6.5rem" @mouseenter.native="focustd3=1"
                    @mouseleave.native="focustd3=0">
                    <span role="button" class="el-input-number__increase1" @mousedown="toIncreasetd1"
                      v-if="focustd2==1||focustd3==1">
                      <i class="el-icon-arrow-up"></i>
                    </span>
                    <span role="button" class="el-input-number__decrease1" @mousedown="toDecreasetd1"
                      v-if="focustd2==1||focustd3==1">
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <el-input-number v-model="ruleFormtd.totalNum" ref="refNumber"
                      @input.native="eventDisposalRangeChangetd()" placeholder="请输入团队人数" controls-position="right"
                      @blur="focustd2=0" @focus="focustd2=1"></el-input-number>
                  </el-form-item>
                  <el-form-item label="未成年人数" style="width:6.5rem" @mouseenter.native="focustd5=1"
                    @mouseleave.native="focustd5=0">
                    <span role="button" class="el-input-number__increase1" @mousedown="toIncreasetd2"
                      v-if="focustd4==1||focustd5==1">
                      <i class="el-icon-arrow-up"></i>
                    </span>
                    <span role="button" class="el-input-number__decrease1" @mousedown="toDecreasetd2"
                      v-if="focustd4==1||focustd5==1">
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <el-input-number v-model="ruleFormtd.underAge" ref="refNumber1"
                      @input.native="eventDisposalRangeChangetd1()" placeholder="请输入未成年人数" controls-position="right"
                      @blur="focustd4=1" @focus="focustd4=1"></el-input-number>
                  </el-form-item>
                  <el-form-item label="65岁以上人数" style="width:6.5rem" @mouseenter.native="focustd7=1"
                    @mouseleave.native="focustd7=0">
                    <span role="button" class="el-input-number__increase1" @mousedown="toIncreasetd3"
                      v-if="focustd6==1||focustd7==1">
                      <i class="el-icon-arrow-up"></i>
                    </span>
                    <span role="button" class="el-input-number__decrease1" @mousedown="toDecreasetd3"
                      v-if="focustd6==1||focustd7==1">
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <el-input-number v-model="ruleFormtd.elderly" ref="refNumber2"
                      @input.native="eventDisposalRangeChangetd2()" placeholder="请输入65岁以上人数" controls-position="right"
                      @blur="focustd6=0" @focus="focustd6=1"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div style="flex: 1;" class="selfBut selfBut1">
                <div style="display: flex;justify-content: flex-end;margin-bottom:  0.625rem;">
                  <div style="flex: 0 0 1.925rem;" class="addSty">
                    <el-button icon="el-icon-download" @click="getTeamZip">模板下载</el-button>
                  </div>
                </div>
                <el-form-item label="领队姓名" prop="teamLeaderName">
                  <el-input v-model="ruleFormtd.teamLeaderName" placeholder="请输入领队姓名" maxlength="5"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phoneNum">
                  <el-input v-model="ruleFormtd.phoneNum" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="讲解服务">
                  <el-select v-model="ruleFormtd.guideIs" placeholder="请选择是否需要讲解服务">
                    <el-option :label="item.label" :value="item.value" v-for="(item,index) in optionListtd1"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="大巴停车位预留" style="display: table;content:''" @mouseenter.native="focustd1=1" @mouseleave.native="focustd1=0">
                  <span role="button" class="el-input-number__increase1" @mousedown="toIncreasetd" v-if="focustd==1||focustd1==1">
                    <i class="el-icon-arrow-up"></i>
                  </span>
                  <span role="button" class="el-input-number__decrease1" @mousedown="toDecreasetd" v-if="focustd==1||focustd1==1">
                    <i class="el-icon-arrow-down"></i>
                  </span>
                  <el-input-number v-model="ruleFormtd.busesNum" placeholder="请输入大巴车数量" controls-position="right" @blur="focustd=0" @focus="focustd=1" :min="1"></el-input-number>
              </el-form-item> -->
                <el-form-item label="预约留言">
                  <el-input v-model="ruleFormtd.note" placeholder="请输入预约留言" maxlength="50"></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item style="text-align: center;margin-top: 0.25rem;margin-bottom:0" class="butStym">
              <el-button class="prevStep" @click="toCanceltd">上一步</el-button>
              <el-button type="primary" @click="submitFormtd('ruleFormtd')" class="submitStep">提交</el-button>

            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button class="nextBut" type="primary" @click="toConfirm">下一步</el-button>
    </span> -->
    </el-dialog>
    <el-dialog class="selfDiag" title="本人承诺" :visible.sync="centerDialogVisibletd3" width="30%" center>
      <div style="text-align: left;font-size: 0.275rem;color: #333333;line-height: 0.55rem;">
        一、本人及随行人员参观科技馆前7天内：无发热、咳嗽、发力等症状；无国内中高风险地区旅居史；没有接触新冠肺炎确诊病例、无症状感染者或密切接触者<br>
        二、本人及随行人员10天内无境外旅居史；<br>
        三、本人及随行人员不是仍处于康复或隔离期的病例无症状感染者或密接者。<br>
      </div>
      <div
        style="margin-top: 0.25rem;text-align: left;font-size: 0.275rem;font-weight: bold;color: #333333;line-height: 0.55rem;">
        以上内容属实，如隐瞒、虚报、谎报，本人承担一切法律责任和相应后果。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelBut" @click="tocanceltd1">取 消</el-button>
        <el-button class="confirmBut" :disabled="disabledTeam" type="primary" @click="toselfAppointtd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="selfDiaguis2" title="团队预约" :visible.sync="centerDialogVisibletd4" width="30%" center>
      <div id="consultpage1">
        <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;">
          <img src="./image/selfFinish.png" style="width: 4.1125rem;height: 3.8625rem;margin-top: 1.65rem;">
        </div>
        <div style="width:100%;text-align:center;font-size: 0.3rem;color: #333333;">预约已提交成功，详情请前往<span
            style="cursor:pointer;color: #3C7CFF;">&nbsp;我的预约&nbsp;</span>中查看</div>
        <div style="text-align: center;">
          <el-button class="prevStep" style="margin-top: 0.75rem;" @click='toCancelAppointtd'>取消</el-button>
          <el-button type="primary" class="submitStep" style="margin-top: 0.75rem;" @click="toPersontd">查看</el-button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button class="cancelBut" @click="centerDialogVisible6 = false">取 消</el-button>
      <el-button class="confirmBut" type="primary" @click="sendCapture">确 定</el-button>
    </span> -->
    </el-dialog>
  </div>
</template>

<script>
  import {
    getVenueIntroduction
  } from '@/api/overview/index.js'
  import {
    getCaptchaCache1
  } from '@/api/login.js'
  import {
    makeAppointment
  } from '@/api/selfAppoint/index.js'
  import {
    getTeamZip,
    makeTeamAppointment
  } from '@/api/teamAppoint/index.js'
  import Cookies from 'js-cookie'
  import {
    getMe
  } from '@/api/login.js'
  import {
    findArea
  } from '@/api/navigation/index.js'
  import {
    gethall,
    pageFilms
  } from '@/api/cinema/index.js'
  import {
    getList as getActivityList
  } from '@/api/activity/index.js'
  import {
    findAppointmentDate,
    findAppointmentTimeQuantum
  } from '@/api/selfAppoint/index.js'
  import {
    listActivateVipType,
    visitorInfo
  } from '@/api/member/index'
  //资讯列表接口
  import {
    getInformList
  } from '@/api/information/index.js'
  import {
    getAppointmentNotice
  } from '@/api/selfAppoint/index.js'
  //内容管理类型
  import {
    getInfo,
    getcontenconnecconfigure,
    getHomePage,
    gateCount,
    nominateSwitch
  } from '@/api/index/index.js'
  import Swiper from "swiper";
  import 'swiper/css/swiper.css';
  import {
    HappyScroll
  } from 'vue-happy-scroll'
  // 引入css，推荐将css放入main入口中引入一次即可。
  import 'vue-happy-scroll/docs/happy-scroll.css'
  import NoticeBar from '@/components/Slider'
  import Menu from "@/components/Menu";
  import Footer from "@/components/Footer";

  export default {
    name: 'home',
    data() {
      let that=this
      //验证手机号的规则
      var checkteamNumber = (rule, value, cb) => {
        if (value >= 20) {
          //合法的手机号
          return cb();
        }
        //手机号不合法
        cb(new Error('团队人数最低20人起步'));
      }
      //验证手机号的规则
      var checkNumber = (rule, value, cb) => {
        if (value <= 8) {
          //合法的手机号
          return cb();
        }
        //手机号不合法
        cb(new Error('大巴数量为1-8量'));
      }
      //验证手机号的规则
      var checkMobile = (rule, value, cb) => {
        const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        if (regMobile.test(value)) {
          //合法的手机号
          return cb();
        }
        //手机号不合法
        cb(new Error('手机号码格式不正确'));
      }
      var checkIdentitytionId = (rule, value, callback) => {
        //身份证
        if(that.ruleForm.idcardType==10){
          if (!value) {
            return callback(new Error("证件号码不能为空"));
          }
          if (!/(^\d{17}(\d|X|x)$)/.test(value)) {
            callback(new Error("您输入的证件号码长度或格式错误"));
          }
          //身份证城市
          var aCity = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
          };
          if (!aCity[parseInt(value.substr(0, 2))]) {
            callback(new Error("您的身份证地区非法"));
          }
          // 出生日期验证
          var sBirthday = (
              value.substr(6, 4) +
              "-" +
              Number(value.substr(10, 2)) +
              "-" +
              Number(value.substr(12, 2))
            ).replace(/-/g, "/"),
            d = new Date(sBirthday);
          if (
            sBirthday !=
            d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
          ) {
            callback(new Error("身份证上的出生日期非法"));
          }

          // 身份证号码校验
          var sum = 0,
            weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
            codes = "10X98765432";
          for (var i = 0; i < value.length - 1; i++) {
            sum += value[i] * weights[i];
          }
          var last = codes[sum % 11]; //计算出来的最后一位身份证号码
          if (value[value.length - 1] != last) {
            callback(new Error("您输入的证件号码非法"));
          }
          callback();
        //港澳台通行证
        }else if(that.ruleForm.idcardType==20){
          if (!value) {
            return callback(new Error("证件号码不能为空"));
          }
          if (!/^[A-Za-z]\d{10}$/.test(value)) {
            callback(new Error("您输入的证件号码长度或格式错误"));
          }

          callback();
        }

      }
      var checkIdentitytionId2 = (rule, value, callback) => {
            if (!value) {
              return callback(new Error("证件号码不能为空"));
            }
            if (!/(^\d{17}(\d|X|x)$)/.test(value)) {
              callback(new Error("您输入的身份证长度或格式错误"));
            }
            //身份证城市
            var aCity = {
              11: "北京",
              12: "天津",
              13: "河北",
              14: "山西",
              15: "内蒙古",
              21: "辽宁",
              22: "吉林",
              23: "黑龙江",
              31: "上海",
              32: "江苏",
              33: "浙江",
              34: "安徽",
              35: "福建",
              36: "江西",
              37: "山东",
              41: "河南",
              42: "湖北",
              43: "湖南",
              44: "广东",
              45: "广西",
              46: "海南",
              50: "重庆",
              51: "四川",
              52: "贵州",
              53: "云南",
              54: "西藏",
              61: "陕西",
              62: "甘肃",
              63: "青海",
              64: "宁夏",
              65: "新疆",
              71: "台湾",
              81: "香港",
              82: "澳门",
              91: "国外"
            };
            if (!aCity[parseInt(value.substr(0, 2))]) {
              callback(new Error("您的身份证地区非法"));
            }
            // 出生日期验证
            var sBirthday = (
                value.substr(6, 4) +
                "-" +
                Number(value.substr(10, 2)) +
                "-" +
                Number(value.substr(12, 2))
              ).replace(/-/g, "/"),
              d = new Date(sBirthday);
            if (
              sBirthday !=
              d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
            ) {
              callback(new Error("身份证上的出生日期非法"));
            }

            // 身份证号码校验
            var sum = 0,
              weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
              codes = "10X98765432";
            for (var i = 0; i < value.length - 1; i++) {
              sum += value[i] * weights[i];
            }
            var last = codes[sum % 11]; //计算出来的最后一位身份证号码
            if (value[value.length - 1] != last) {
              callback(new Error("您输入的证件号码非法"));
            }
            callback();
      }
      var checkIdentitytionId3 = (rule, value, callback) => {
            if (!value) {
              return callback(new Error("证件号码不能为空"));
            }
            if (!/^[A-Za-z]\d{10}$/.test(value)) {
              callback(new Error("您输入的证件号码长度或格式错误"));
            }

            callback();
      }
      return {
        cardType:[
          {label:'身份证',value:10},
          {label:'港澳台通行证',value:20},
        ],
        focus2: [],
        focus3: [],
        disabledSelf: false,
        disabledTeam: false,
        errorxxMsgtd: '',
        errorMsgtd: '',
        focustd: 0,
        focustd1: 0,
        focustd2: 0,
        focustd3: 0,
        focustd4: 0,
        focustd5: 0,
        focustd6: 0,
        focustd7: 0,
        schoolOptionListtd: [{
            id: 1,
            value: 1,
            label: '幼儿园(学生)'
          },
          {
            id: 2,
            value: 2,
            label: '幼儿园(亲子)'
          },
          {
            id: 3,
            value: 3,
            label: '小学(1-3年级)'
          },
          {
            id: 4,
            value: 4,
            label: '小学(4-6年级)'
          },
          {
            id: 5,
            value: 5,
            label: '小学(全年级)'
          },
          {
            id: 6,
            value: 6,
            label: '初中'
          },
          {
            id: 7,
            value: 7,
            label: '高中'
          },
          {
            id: 8,
            value: 8,
            label: '其他院校'
          },
        ],
        optionListtd: [{
            id: 0,
            value: 0,
            label: '学校团队'
          },
          {
            id: 1,
            value: 1,
            label: '政府单位'
          },
          {
            id: 2,
            value: 2,
            label: '企事业团队'
          },
          {
            id: 3,
            value: 3,
            label: '旅行团队'
          },
          {
            id: 4,
            value: 4,
            label: '教培机构'
          },
          {
            id: 5,
            value: 5,
            label: '其他团队'
          },
        ],
        optionListtd1: [{
            id: 1,
            value: 1,
            label: '是'
          },
          {
            id: 0,
            value: 0,
            label: '否'
          },
        ],
        DisApplyTimeHourstd: '00:00:01 - 23:59:59',
        paramstd: {
          startTime: '', //访客通行开始时间
          endTime: '', //访客通行结束时间
        },
        centerDialogVisibletd: false,
        personListtd: [
          // {id:1,name:'',card:''},
        ],
        ruleFormtd: {
          "appointmentDate": "",
          "appointmentTimeQuantum": "",
          "busesNum": undefined,
          "captcha": "",
          "captchaKey": "",
          "elderly": undefined,
          "endTime": "",
          "guideIs": '',
          "note": "",
          "personnelInformation": "",
          "phoneNum": '',
          "roundList": [],
          "schoolType": '',
          "startTime": "",
          "teamLeaderName": "",
          "teamName": "",
          "teamType": "",
          "totalNum": undefined,
          "underAge": undefined
        },
        rulestd: {
          teamType: [{
            required: true,
            message: '请输入团队类型',
            trigger: 'change'
          }, ],
          teamName: [{
            required: true,
            message: '请输入团队名称',
            trigger: 'blur'
          }, ],
          totalNum: [{
              required: true,
              message: '请输入团队人数',
              trigger: 'blur'
            },
            {
              validator: checkteamNumber,
              trigger: 'blur'
            }
          ],
          teamLeaderName: [{
            required: true,
            message: '请输入领队名称',
            trigger: 'blur'
          }, ],
          phoneNum: [{
              required: true,
              message: '请输入手机号码',
              trigger: 'blur'
            },
            {
              validator: checkMobile,
              trigger: 'blur'
            }
          ],
          guideIs: [{
            required: true,
            message: '请选择是否需要讲解服务',
            trigger: 'change'
          }, ],
          busesNum: [{
              required: true,
              message: '请输入大巴停车预留',
              trigger: 'blur'
            },
            {
              validator: checkNumber,
              trigger: 'blur'
            }
          ]
        },
        personList1: [],
        captchaNum: '',
        captcha: '',
        captchaKey: '',
        date: '',
        time: '',
        limit: '',
        centerDialogVisibletd: false,
        centerDialogVisible: false,
        centerDialogVisibletd2: false,
        centerDialogVisibletd3: false,
        centerDialogVisibletd4: false,
        centerDialogVisible3: false,
        yzmDiag: false,
        personList: [],
        ruleForm: {
          realName: '',
          idNum: '',
          phoneNum: '',
          idcardType:10
        },
        rules: {
          realName: [{
            required: true,
            message: '真实姓名不能为空',
            trigger: 'blur'
          }],
          idcardType: [{
            required: true,
            message: '证件类型不能为空',
            trigger: 'blur'
          }],
          phoneNum: [{
              required: true,
              message: '手机号码不能为空',
              trigger: 'blur'
            },
            {
              validator: checkMobile,
              trigger: 'blur'
            }
          ],
        },
        rules1: {
          idcardType: [{
            required: true,
            message: '证件类型不能为空',
            trigger: 'blur'
          }],
          realName: [{
            required: true,
            message: '真实姓名不能为空',
            trigger: 'blur'
          }, ],
          // age: [{
          //   required: true,
          //   message: '年龄不可为空',
          //   trigger: 'blur'
          // }, ],
          // school: [{
          //   required: true,
          //   message: '学校不可为空',
          //   trigger: 'blur'
          // }, ],
        },
        timer: null,
        idNum: [
          {
              required: true,
              message: '证件号码不能为空',
              trigger: 'change'
          },
          {
            validator: checkIdentitytionId2,
            trigger: 'blur'
          }
        ],
        idNum1: [
          {
              required: true,
              message: '证件号码不能为空',
              trigger: 'change'
          },
          {
            validator: checkIdentitytionId3,
            trigger: 'blur'
          }
        ],
        date: '',
        time: '',
        ticket: '',
        remainingTicket: '',
        choosedDateDeadLine: '', // 预约结束时间
        dateActive: null,
        timeActive: null,
        dateList: [],
        timeList: [],
        timer: null,
        dataInfo: {
          openContent: '',
          appointmentContent: '',
          content: '',
        },
        centerDialogVisible: false,
        centerDialogVisible1: false,
        centerDialogVisibletd1: false,
        centerDialogVisible2: false,
        centerDialogVisible6: false,
        centerDialogVisible7: false,
        activeYy: null,
        menuShow: true,
        commonList: [],
        carouselList: [],
        noticeList: [],
        filmList: [],
        pageSize: 3,
        pageSize5: 5,
        page: 1,
        activityList: [],
        // 新闻资讯
        linkList: [],
        infoList: [],
        contentInfo: {},
        knowAutoplay: true,
        knowAutoplayzx: true,
        downto: '',
        down: '',
        size: 150,
        listData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        activeClass1: false,
        activeClass: false,
        newsShow: false,
        beforeScrollTop: 0,
        timer1: '',
        indexActive: 0,
        indexActivej: 0,
        indexActiven: 0,
        cinemaList: [],
        itemList: [{
            id: 1,
            name: '科学探究实验室配置',
            time: '2022-01-26--2022-01-30',
            address: '青岛科技馆'
          },
          {
            id: 2,
            name: '科学探究实验室配置',
            time: '2022-01-26--2022-01-30',
            address: '青岛科技馆'
          },
          {
            id: 3,
            name: '科学探究实验室配置',
            time: '2022-01-26--2022-01-30',
            address: '青岛科技馆'
          },
        ],
        imguList: [{
            id: 1,
            appUrl: require('./image/img1.png')
          },
          {
            id: 1,
            appUrl: require('./image/img2.png')
          },
          // {id:1,appUrl:require('./image/img2.png')},
        ],
        imguList1: [{
            id: 1,
            appUrl: require('./image/img1.png')
          },
          {
            id: 1,
            appUrl: require('./image/img2.png')
          },
          {
            id: 1,
            appUrl: require('./image/img2.png')
          },
        ],
        appoint: [{
            id: 1,
            img: require('./image/yy1.png'),
            name: '个人预约',
            desc: '体验缤纷海洋',
            desc1: '的探索之旅'
          },
          // {
          //   id: 2,
          //   img: require('./image/yy2.png'),
          //   name: '团队预约',
          //   desc: '与朋友一起畅',
          //   desc1: '玩科技馆'
          // },
          // {
          {
            id: 2,
            img: require('./image/yy2.png'),
            name: '临展预约',
            desc: '与朋友一起参',
            desc1: '观临展'
          },
          // {
          //   id: 3,
          //   img: require('./image/yy3.png'),
          //   name: '影院预约',
          //   desc: '身临其境的梦',
          //   desc1: '幻海洋'
          // },
          {
            id: 4,
            img: require('./image/yy4.png'),
            name: '活动预约',
            desc: '丰富有趣的互',
            desc1: '动活动与比赛'
          },
        ],
        introduction: '',
        picture: '',
        beforeScrollTop: 0,
        peopleCount: 0,
        ticketNumber: 0,
        datetd: '',
        timetd: '',
        tickettd: '',
        remainingTickettd: '',
        paramstd: {
          startTime: '', //访客通行开始时间
          endTime: '', //访客通行结束时间
        },
        dateActivetd: null,
        timeActivetd: null,
        dateListtd: [],
        timeListtd: [],
        isInfoRm:false
      }
    },
    // },
    destroyed() {
      // window.removeEventListener('scroll',this.handleScroll,true)
    },
    created() {
      // this.centerDialogVisible1 = true
      //票数
      if (Cookies.get('userInfoqd')) {
        if (JSON.parse(Cookies.get('userInfoqd')).token) {
          this.getTicketNumber()
        }
      }

      //顶部轮播
      this.getHomePage()
      //通知公告
      this.getInformList(0)
      //新闻资讯
      this.getInformList(1)
      //友情链接
      this.getcontenconnecconfigure()
      //教育活动
      this.getActivityList([], [])
      this.gethall()
      this.pageFilms()
      // 入馆人数
      // this.gateCount(this.timeFormatDate(new Date()), this.timeFormatSeconds(new Date()))

      //展览推荐
      // this.findArea()
      this.nominateSwitch()
      this.getVenueIntroduction()
      console.log(this.$route.params);
      const params = this.$route.params
      if(params.inform){

       this.findAppointmentDate()
       this.findAppointmentTimeQuantum(params.inform.appointmentDate)
        this.isInfoRm = params
        console.log( this.isInfoRm);
      }

    },
    mounted() {
      this.windowAddMouseWheel()
      const scrollview = this.$refs['scrollview']
      scrollview.addEventListener('scroll', this.handleScroll, true)
      // window.addEventListener("scroll", ,true)
      //内容管理
      this.getInfo()


    },
    components: {
      Menu,
      Footer,
      NoticeBar,
      'happy-scroll': HappyScroll
    },
    computed: {
      sizeComputed: function() {
        return this.size + '%';
      },
    },
    beforeDestroy() {
      // alert('aaa')
    },
    watch: {
      'ruleFormtd.schoolType': {
        immediate: true,
        handler(val, old) {
          if (val) {
            this.errorxxMsgtd = ''
          }
        }
      }
    },
    methods: {
      getRouteParams(){
        const params = this.$route.params
        if(!params.inform) return
        const index = this.dateList.findIndex((item,index) => item.date === params.inform.appointmentDate)
          console.log(index);
        if(index !== -1){
          this.dateSelect(this.dateList[index],index)
          this.ruleForm.realName = params.inform.userName
          this.ruleForm.idNum = params.inform.idCard
          this.ruleForm.phoneNum = params.inform.tel
          console.log(params.personList);
          this.personList = params.personList
        }

          this.centerDialogVisible1 = true
      },
      changeCard1(index) {
        console.log(this.personList)
        this.personList[index].idNum = ''
        const field = 'idNum'; // 替换为要清除校验的字段名
        this.$refs['ruleForm1'][index].clearValidate(field);
      },
      changeCard() {
        this.ruleForm.idNum = ''
        const field = 'idNum'; // 替换为要清除校验的字段名
        this.$refs['ruleForm'].clearValidate(field);
      },
      eventDisposalRangeChangeage(value) {

        this.personList.forEach((item, index) => {
          let key = this.$refs.refNumber1age[index].displayValue;
          if (key) {
            if (key.length > 3) {
              this.personList[index].age = key.slice(0, 3);
            } else {
              this.personList[index].age = key
            }
          }
        })

        // if (value != undefined) {
        //   this.$refs.ruleForm.clearValidate("age");
        // }

      },
      toIncreaseage(index) {
        if (!this.personList[index].age) {
          this.personList[index].age = 0
        }
        this.personList[index].age++
        this.$refs['ruleForm1'][index].validateField("age")
      },
      toDecreaseage(index) {
        if (!this.personList[index].age) {
          this.personList[index].age = 0
        }
        this.personList[index].age--
        this.$refs['ruleForm1'][index].validateField("age")
      },
      mouseenterage(index) {
        this.focus3[index] = 1
        this.focus3 = [...this.focus3]
      },
      mouseleaveage(index) {
        this.focus3[index] = 0
        this.focus3 = [...this.focus3]
      },
      toCancelAppointtd() {
        this.centerDialogVisibletd4 = false
        this.datetd = ''
        this.timetd = ''
        this.timeListtd = []
        this.dateActivetd = null
        this.timeActivetd = null
        this.paramstd = {
          startTime: '', //访客通行开始时间
          endTime: '', //访客通行结束时间
        }
        this.centerDialogVisibletd1 = true
        this.findAppointmentDatetd()
        this.ruleFormtd = {
            "appointmentDate": "",
            "appointmentTimeQuantum": "",
            "busesNum": undefined,
            "captcha": "",
            "captchaKey": "",
            "elderly": undefined,
            "endTime": "",
            "guideIs": '',
            "note": "",
            "personnelInformation": "",
            "phoneNum": '',
            "roundList": [],
            "schoolType": '',
            "startTime": "",
            "teamLeaderName": "",
            "teamName": "",
            "teamType": "",
            "totalNum": undefined,
            "underAge": undefined
          },
          this.$refs['ruleForm'].clearValidate();
        this.$refs['ruleFormtd'].clearValidate();
      },
      toCancelAppoint() {
        this.yzmDiag = false
        this.centerDialogVisible6 = false
        this.date = ''
        this.time = ''
        this.timeList = []
        this.dateActive = null
        this.timeActive = null
        this.centerDialogVisible1 = true
        this.findAppointmentDate()
        this.personList = []
        this.ruleForm = {
          realName: '',
          idNum: '',
          phoneNum: '',
          idcardType:10
        }
        this.$refs['ruleForm'].clearValidate();
      },
      getVenueIntroduction() {
        getVenueIntroduction({}).then(res => {
          if (res.data.code == 0) {
            this.introduction = res.data.data.introduction
            if (res.data.data.picture) {
              this.picture = process.env.VUE_APP_IMG_URL + res.data.data.picture
            }
          }
        })
      },
      tocanceltd1() {
        this.centerDialogVisibletd3 = false
        this.centerDialogVisibletd2 = true
      },
      cancelSelf() {
        this.centerDialogVisible3 = false
        this.centerDialogVisible2 = true
      },
      cancelSelf1() {
        this.yzmDiag = false
        this.centerDialogVisible2 = true
      },
      toPersontd() {
        this.$router.push({
          name: 'PersonInfo',
          query: {
            cateId: 0,
            id: 1
          }
        })
      },
      toConfirmtd1() {
        if (this.datetd && this.timetd) {
          this.centerDialogVisibletd2 = true
          this.$refs['ruleFormtd'].clearValidate()
        } else {
          if (!this.datetd) {
            this.$message.error('请选择参观日期');
          } else {
            if (!this.timetd) {
              this.$message.error('请选择开馆时间');
            } else {
              // if(!this.paramstd.startTime||!this.paramstd.endTime){
              //    this.$message.error('请选择参观时间');
              // }
            }
          }
        }
      },
      change() {

      },
      eventDisposalRangeChangetd(value) {
        const key = this.$refs.refNumber.displayValue;
        if (key.length > 4) {
          this.ruleFormtd.totalNum = key.slice(0, 4);
        } else {
          this.ruleFormtd.totalNum = key
        }
      },
      eventDisposalRangeChangetd1(value) {
        const key = this.$refs.refNumber1.displayValue;
        if (key.length > 4) {
          this.ruleFormtd.underAge = key.slice(0, 4);
        } else {
          this.ruleFormtd.underAge = key
        }
      },
      eventDisposalRangeChangetd2(value) {
        const key = this.$refs.refNumber2.displayValue;
        if (key.length > 4) {
          this.ruleFormtd.elderly = key.slice(0, 4);
        } else {
          this.ruleFormtd.elderly = key
        }
      },
      changeTeamtd() {
        this.ruleFormtd.schoolType = ''
      },

      getTeamZip() {
        getTeamZip().then(res => {
          if (res.data.code == 0) {
            const link = document.createElement('a');
            // 这里是将链接地址url转成blob地址，
            fetch(process.env.VUE_APP_IMG_URL + res.data.data.url).then(res => res.blob()).then(blob => {
              link.href = URL.createObjectURL(blob)
              // 下载文件的名称及文件类型后缀
              link.download = res.data.data.name + '.' + res.data.data.url.split('.')[1];
              document.body.appendChild(link)
              link.click()
              //在资源下载完成后 清除 占用的缓存资源
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            });
            // let a = document.createElement('a')
            // if(res.data.data.url){
            //   a.href = process.env.VUE_APP_IMG_URL+res.data.data.url
            // }else{
            //   a.href =''
            // }
            // a.click();
          }
        })
      },
      toCanceltd() {
        this.centerDialogVisibletd2 = false
        this.centerDialogVisibletd1 = true
      },
      toIncreasetd1() {
        if (!this.ruleFormtd.totalNum) {
          this.ruleFormtd.totalNum = 0
        }
        this.ruleFormtd.totalNum++
        this.$refs['ruleFormtd'].validateField("totalNum")
      },
      toDecreasetd1() {
        if (!this.ruleFormtd.totalNum) {
          this.ruleFormtd.totalNum = 0
        }
        this.ruleFormtd.totalNum--
        this.$refs['ruleFormtd'].validateField("totalNum")
      },

      toIncreasetd2() {
        if (!this.ruleFormtd.underAge) {
          this.ruleFormtd.underAge = 0
        }
        this.ruleFormtd.underAge++
      },
      toDecreasetd2() {
        if (!this.ruleFormtd.underAge) {
          this.ruleFormtd.underAge = 0
        }
        this.ruleFormtd.underAge--
      },

      toIncreasetd3() {
        if (!this.ruleFormtd.elderly) {
          this.ruleFormtd.elderly = 0
        }
        this.ruleFormtd.elderly++
      },
      toDecreasetd3() {
        if (!this.ruleFormtd.elderly) {
          this.ruleFormtd.elderly = 0
        }
        this.ruleFormtd.elderly--
      },
      toIncreasetd() {
        if (!this.ruleFormtd.busesNum) {
          this.ruleFormtd.busesNum = 0
        }
        this.ruleFormtd.busesNum++
        this.$refs['ruleFormtd'].validateField("busesNum")
      },
      toDecreasetd() {
        if (!this.ruleFormtd.busesNum) {
          this.ruleFormtd.busesNum = 0
        }
        this.ruleFormtd.busesNum--
        this.$refs['ruleFormtd'].validateField("busesNum")
      },
      submitFormtd(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.ruleFormtd.teamType == 0) {
              if (!this.ruleFormtd.schoolType) {
                this.errorxxMsgtd = '请选择学校团队类型'
              } else {
                this.errorxxMsgtd = ''
                if (this.ruleFormtd.totalNum < parseFloat(this.ruleFormtd.underAge) + parseFloat(this.ruleFormtd
                    .elderly)) {
                  this.$message({
                    message: '未成年人数+65岁以上人数不能大于团队总人数',
                    type: 'warning'
                  });
                } else {
                  this.centerDialogVisibletd = false
                  this.centerDialogVisibletd1 = false
                  this.centerDialogVisibletd2 = false
                  // this.centerDialogVisibletd3=true
                  this.toselfAppointtd()
                }
              }
            } else {
              if (this.ruleFormtd.totalNum < parseFloat(this.ruleFormtd.underAge) + parseFloat(this.ruleFormtd
                  .elderly)) {
                this.$message({
                  message: '未成年人数+65岁以上人数不能大于团队总人数',
                  type: 'warning'
                });
              } else {
                this.centerDialogVisibletd = false
                this.centerDialogVisibletd1 = false
                this.centerDialogVisibletd2 = false
                // this.centerDialogVisibletd3=true
                this.toselfAppointtd()
              }
            }
          } else {
            if (this.ruleFormtd.teamType == 0) {
              if (!this.ruleFormtd.schoolType) {
                this.errorxxMsgtd = '请选择学校团队类型'
              } else {
                this.errorxxMsgtd = ''
              }
            } else {}
            return false;
          }
        });
      },




      // compare(date1){
      //    var oDate1 = new Date(date1);
      //    var oDate2 = new Date();
      //    if (oDate1.getTime() < oDate2.getTime()){
      //      return false
      //    }else{
      //      return true
      //    }
      // },
      findAppointmentDatetd() {
        findAppointmentDate().then(res => {
          if (res.data.code == 0) {
            let dateList = res.data.data
            dateList.forEach(item => {
              if (item.isClose == 1) {
                item.disabled = true
              } else {
                if (item.appointmentBeginTime) {
                  let date = new Date().getTime()
                  let date1 = new Date(item.appointmentBeginTime).getTime()
                  if (date > date1) {
                    item.disabled = false
                  } else {
                    item.disabled = true
                  }
                } else {
                  this.disabled = false
                }
              }
            })
            this.dateListtd = dateList
          }
        })
      },
      dateSelecttd(item, index) {
        if (!item.disabled) {
          this.dateActivetd = index
          this.datetd = item.date
          this.timeActivetd = null
          this.timetd = ''
          this.remainingTickettd = 0
          this.findAppointmentTimeQuantumtd(item.date)
        }
      },
      findAppointmentTimeQuantumtd(appointmentDate) {
        findAppointmentTimeQuantum({
          appointmentDate: appointmentDate
        }).then(res => {
          if (res.data.code == 0) {
            this.timeListtd = res.data.data
            this.timeListtd.forEach(item => {
              item.show = this.compare(this.datetd + ' ' + item.during.split('~')[1])
            })
          }
        })
      },
      timeSelecttd(item, index) {
        if (item.show) {
          this.timeActivetd = index
          this.timetd = item.during
          this.tickettd = item.visitorCeiling
          this.remainingTickettd = item.remainingTicket
        }
      },
      toConfirmtd() {
        this.datetd = ''
        this.timetd = ''
        this.timeListtd = []
        this.dateActivetd = null
        this.timeActivetd = null
        this.paramstd = {
          startTime: '', //访客通行开始时间
          endTime: '', //访客通行结束时间
        }
        this.centerDialogVisibletd1 = true
        this.findAppointmentDatetd()
        this.ruleFormtd = {
            "appointmentDate": "",
            "appointmentTimeQuantum": "",
            "busesNum": undefined,
            "captcha": "",
            "captchaKey": "",
            "elderly": undefined,
            "endTime": "",
            "guideIs": '',
            "note": "",
            "personnelInformation": "",
            "phoneNum": '',
            "roundList": [],
            "schoolType": '',
            "startTime": "",
            "teamLeaderName": "",
            "teamName": "",
            "teamType": "",
            "totalNum": undefined,
            "underAge": undefined
          },
          this.$refs['ruleForm'].clearValidate();
        this.$refs['ruleFormtd'].clearValidate();
      },
      makeAppointment() {
        let data = {
          "appointmentDate": this.date,
          "appointmentPeoples": [],
          "captcha": this.captchaNum,
          "captchaKey": this.captchaKey,
          "appointmentTimeQuantum": this.time,
          "phoneNum": this.ruleForm.phoneNum
        }
        data.appointmentPeoples.push({
          realName: this.ruleForm.realName,
          idNum: this.ruleForm.idNum,
          idcardType:this.ruleForm.idcardType,
        })
        data.appointmentPeoples = data.appointmentPeoples.concat(this.personList)
        this.disabledSelf = true
        makeAppointment(data).then(res => {
          if (res.data.code == 0) {
            this.centerDialogVisible = false

            this.centerDialogVisible2 = false
            this.disabledSelf = false
            if(this.isInfoRm){
              this.centerDialogVisible7 = true
            }else{
              this.centerDialogVisible6 = true
            }
          } else {
            // this.getCaptchaCache()
            this.disabledSelf = false
            this.centerDialogVisible2 = true
            this.$message.warning(res.data.msg)
          }
        })

      },
      makeTeamAppointment() {
        this.ruleFormtd.appointmentDate = this.datetd
        this.ruleFormtd.appointmentTimeQuantum = this.timetd
        this.ruleFormtd.startTime = this.paramstd.startTime
        this.ruleFormtd.endTime = this.paramstd.endTime
        this.disabledTeam = true
        makeTeamAppointment(this.ruleFormtd).then(res => {
          if (res.data.code == 0) {
            this.centerDialogVisibletd3 = false
            this.centerDialogVisibletd4 = true
            this.disabledTeam = false
          } else {
            this.disabledTeam = false
          }
        })
      },
      toInfoRm(){
        // console.log(this.isInfoRm);
        // this.$router.push({name:'EduInfo',query:{id:this.isInfoRm.id, cate:this.isInfoRm.cate},params: { inform:this.isInfoRm.inform,personList:this.personList }})
        this.centerDialogVisible7 = false
      },
      toselfAppointtd() {
        this.makeTeamAppointment()
        // this.centerDialogVisible=false
        // this.$router.push({name:'TeamHint'})
      },
      toselfAppoint() {
        this.makeAppointment()
      },
      //个人预约
      toPerson() {
        this.$router.push({
          name: 'PersonInfo',
          query: {
            cateId: 0,
            id: 0
          }
        })
      },
      sendCapture() {
        this.captchaNum = ''
        this.getCaptchaCache()
        this.centerDialogVisible = false
        this.centerDialogVisible1 = false
        this.centerDialogVisible2 = false
        this.centerDialogVisible3 = false
        this.yzmDiag = true
      },
      getCaptchaCache() {
        getCaptchaCache1().then(res => {
          if (res.data.code == 0) {
            this.captcha = res.data.captcha.captcha
            this.captchaKey = res.data.captcha.captchaKey
          }
        })
      },

      toCancel() {
        this.centerDialogVisible2 = false
        this.centerDialogVisible1 = true
      },
      submitFormu(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.personList.length == 0) {
              if (this.remainingTicket === 0) {
                this.$message.warning('今日预约已满~')
              } else {
                if (this.personList.length >= this.remainingTicket) {
                  this.$message.warning(`今日可预约剩余${this.remainingTicket}张`)
                } else {
                  this.centerDialogVisible = false
                  this.centerDialogVisible1 = false
                  // this.centerDialogVisible2=false
                  // this.$message.error('随行人员信息不可为空')
                  // this.yzmDiag=true
                  // this.sendCapture()
                  this.toselfAppoint()
                }
              }
            } else {
              let jy = []
              this.$refs['ruleForm1'].forEach(obj => {
                obj.validate((valid) => {
                  if (valid) {
                    jy.push(1)

                  } else {
                    jy.push(0)
                    return false
                  }
                })
              })
              if (jy.indexOf(0) != -1) {

              } else {
                let uData = []
                let nArr = []
                this.personList.forEach(item => {
                  uData.push(item.idNum)
                })
                if (this.ruleForm.idNum) {
                  uData.push(this.ruleForm.idNum)
                }
                nArr = [...new Set(uData)]
                if (nArr.length < uData.length) {
                  this.$message({
                    message: '证件号码存在重复',
                    type: 'warning'
                  })
                } else {
                  if (this.remainingTicket === 0) {
                    this.$message.warning('今日预约已满~')
                  } else {
                    if (this.personList.length >= this.remainingTicket) {
                      this.$message.warning(`今日可预约剩余${this.remainingTicket}张`)
                    } else {
                      this.centerDialogVisible = false
                      this.centerDialogVisible1 = false
                      // this.centerDialogVisible2=false
                      // this.$message.error('随行人员信息不可为空')
                      // this.yzmDiag=true
                      // this.sendCapture()
                      this.toselfAppoint()
                    }
                  }
                }
              }
            }
          } else {
            this.$refs['ruleForm1'].forEach(obj => {
              obj.validate((valid) => {
                if (valid) {

                } else {
                  return false
                }
              })
            })
            return false;
          }
        });
      },
      // submitFormu(formName) {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      //       if(this.personList.length==0){
      //         this.centerDialogVisible=false
      //         this.centerDialogVisible1=false
      //         this.centerDialogVisible2=false
      //         // this.$message.error('随行人员信息不可为空')
      //         // this.yzmDiag=true
      //         this.sendCapture()
      //       }else{
      //         let jy=[]
      //         this.$refs['ruleForm1'].forEach(obj=>{
      //           obj.validate((valid) => {
      //             if (valid) {
      //               jy.push(1)

      //             }else{
      //               jy.push(0)
      //               return false
      //             }
      //           })
      //         })
      //         if(jy.indexOf(0)!=-1){

      //         }else{
      //           let uData=[]
      //           let nArr=[]
      //           this.personList.forEach(item=>{
      //             uData.push(item.idNum)
      //           })
      //           if(this.ruleForm.idNum){
      //             uData.push(this.ruleForm.idNum)
      //           }
      //           nArr=[...new Set(uData)]
      //           if(nArr.length<uData.length){
      //             this.$message({
      //               message: '身份证号码存在重复',
      //               type: 'warning'
      //             })
      //           }else{
      //             this.centerDialogVisible=false
      //             this.centerDialogVisible1=false
      //             this.centerDialogVisible2=false
      //             this.sendCapture()
      //           }
      //         }
      //       }
      //     } else {
      //       this.$refs['ruleForm1'].forEach(obj=>{
      //         obj.validate((valid) => {
      //           if (valid) {

      //           }else{
      //             return false
      //           }
      //         })
      //       })
      //       return false;
      //     }
      //   });
      // },
      resetForm(formName) {
        this.show = 1
        this.$refs[formName].resetFields();
      },
      addPerson() {
        if (this.personList.length == (this.ticket - 1)) {
          this.$message.error('可预约人数为' + this.ticket + '位');
        } else {
          this.personList.push({
            // id: 1,
            realName: '',
            idNum: '',
            age: undefined,
            school: '',
            idcardType:10
          })
          this.focus2.push(0)
          this.focus3.push(0)
        }
      },
      delPerson(index) {
        this.personList.splice(index, 1)
      },
      toConfirm() {
        this.date = ''
        this.time = ''
        this.timeList = []
        this.dateActive = null
        this.timeActive = null
        this.centerDialogVisible1 = true
        this.findAppointmentDate()
        this.personList = []
        this.ruleForm = {
          realName: '',
          idNum: '',
          phoneNum: '',
          idcardType:10
        }
        this.$refs['ruleForm'].clearValidate();
      },
      toConfirm1() {
        if(!this.date) {
          this.$message.error('请选择参观日期');
            return
        }else if(!this.time) {
          this.$message.error('请选择参观时段');
          return;
        }else {
          if(new Date().getTime() - new Date(this.date + ' ' + this.choosedDateDeadLine).getTime() > 0) {
            this.$message.error('当天预约已结束，请选择其他日期预约');
          }else {
          this.centerDialogVisible2 = true
          this.$refs['ruleForm'].clearValidate();
          this.$refs['ruleForm1'].forEach(obj => {
            obj.clearValidate()
          })
          }
        }

        // if (this.date && this.time) {
        //   this.centerDialogVisible2 = true
        //   this.$refs['ruleForm'].clearValidate();
        //   this.$refs['ruleForm1'].forEach(obj => {
        //     obj.clearValidate()
        //   })
        // } else {
        //   if (!this.date) {
        //     this.$message.error('请选择参观日期');
        //   } else {
        //     if (!this.time) {
        //       this.$message.error('请选择参观时段');
        //     }
        //   }
        // }
      },
      compare(date1) {
        var oDate1 = new Date(date1);
        var oDate2 = new Date();
        if (oDate1.getTime() < oDate2.getTime()) {
          return false
        } else {
          return true
        }
      },
      findAppointmentDate() {
        findAppointmentDate().then(res => {
          if (res.data.code == 0) {
            let dateList = res.data.data
            dateList.forEach(item => {
              if (item.isClose == 1) {
                item.disabled = true
              } else {
                if (item.appointmentBeginTime) {
                  let date = new Date().getTime()
                  let date1 = new Date(item.appointmentBeginTime).getTime()
                  if (date > date1) {
                    item.disabled = false
                  } else {
                    item.disabled = true
                  }
                } else {
                  this.disabled = false
                }
              }
            })
            this.dateList = dateList
            console.log(this.dateList);
            this.getRouteParams()
          }
        })
      },
      dateSelect(item, index) {
        if (!item.disabled) {
          this.dateActive = index
          this.date = item.date
          this.timeActive = null
          this.time = ''
          this.remainingTicket = 0
          this.choosedDateDeadLine = item.deadline

          this.findAppointmentTimeQuantum(item.date)
        }

      },
      findAppointmentTimeQuantum(appointmentDate) {
        findAppointmentTimeQuantum({
          appointmentDate: appointmentDate
        }).then(res => {
          if (res.data.code == 0) {
            this.timeList = res.data.data
            this.timeList.forEach(item => {
              item.show = this.compare(this.date + ' ' + item.during.split('~')[1])
            })
          }
        })
      },
      timeSelect(item, index) {
        if (item.show) {
          this.timeActive = index
          this.time = item.during
          this.ticket = item.visitorCeiling
          this.remainingTicket = item.remainingTicket
        }

      },
      getAppointmentNotice() {
        getAppointmentNotice().then(res => {
          if (res.data.code == 0) {
            if (res.data.data) {
              this.dataInfo = res.data.data
            }

          }
        })
      },
      toOverview() {
        this.$router.push({
          name: 'Overview'
        })
      },
      toEnterYy1(index) {
        this.activeYy = index
      },
      toLeaveYy1(index) {
        this.activeYy = null
      },
      toClickYy1(index) {
        // if(index==2){
        //   this.$message('暂未开放')
        // }else{
          if (Cookies.get('userInfoqd')) {
            if (!JSON.parse(Cookies.get('userInfoqd')).token) {
              this.$message.success('请先登录再操作')
              setTimeout(() => {
                this.$router.push('/login')
              }, 1000)
            } else {
              this.activeYy = index
              if (index == 0) {
                this.getAppointmentNotice()
                this.centerDialogVisible = true
              } else if (index == 1) {
                this.$router.push({
                  name: 'Navigation',
                  query: {
                    id: 1
                  }
                })
                // this.getAppointmentNotice()
                // this.centerDialogVisibletd = true
              }
              // else if (index == 2) {
              //   this.$router.push({
              //     name: 'Cinema'
              //   })
              //   // this.$message('暂未开放')
              // }
              else if (index == 2) {
                this.$router.push({
                  name: 'EduList'
                })
              }
            }
          } else {
            this.$message.success('请先登录再操作')
            setTimeout(() => {
              this.$router.push('/login')
            }, 1000)
          }
        // }


      },
      toOverview() {
        this.$router.push({
          name: 'Overview'
        })
      },
      getTicketNumber() {
        this.menuShow = false
        this.$api.post('/api/getDateAvailableForAppointment', {
          params: {}
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          if (res.data.code == '0') {
            this.ticketNumber = res.data.data[0].visitorCeiling
            this.menuShow = true
          } else if (res.data.code == '403') {
            this.menuShow = true
          } else {
            this.menuShow = true
          }
        })
      },
      async toMember() {
        this.$message('暂未开放')
        // if(Cookies.get('userInfoqd')){
        //   if(!JSON.parse(Cookies.get('userInfoqd')).token){
        //     this.$message.success('请先登录再操作')
        //     setTimeout(()=>{
        //       this.$router.push('/login')
        //     },1000)
        //   }else{
        //     let inOrOut = await this.listVipType();
        //     let isMember = await this.getVipInfo();

        //     if (!inOrOut) {
        //       this.$router.push({
        //         path: '/member/outperiod',
        //       })
        //     } else {
        //       if (!isMember) {
        //         this.$router.push({
        //           path: '/member/member',
        //         })
        //       } else {
        //         this.$router.push({
        //           path: '/member/memberMall'
        //         })
        //       }
        //     }
        //   }
        // }else{
        //   this.$message.success('请先登录再操作')
        //   setTimeout(()=>{
        //     this.$router.push('/login')
        //   },1000)
        // }

      },
      listVipType() {
        return new Promise((resolve, reject) => {
          listActivateVipType().then(res => {
            if (res.data.code == 0) {
              resolve(res.data.data.length > 0 ? true : false)
            }
          })
        })
      },
      getVipInfo() {
        return new Promise((resolve, reject) => {
          visitorInfo().then(res => {
            if (res.data.code == 0) {
              resolve(res.data.data.vipType == 1 ? true : false)
            }
          })
        })
      },
      toFullScreen() {
        this.$message('暂未开放')
      },
      toMoreList() {
        this.$router.push({
          name: 'InfoList',
          query: {
            type: 1
          }
        })
      },
      toMoreList1() {
        this.$router.push({
          name: 'EduList',
          query: {
            id: 1
          }
        })
      },
      toMoreInfo1(item) {
        if (Cookies.get("userInfoqd")) {
          if (!JSON.parse(Cookies.get("userInfoqd")).token) {
            this.$message.success("请先登录再操作");
            // setTimeout(()=>{
            this.$router.push("/login");
            // },1000)
          } else {
            // this.$router.push({name:'EduInfo',query:{id:item.id}})

            localStorage.setItem('EduAdd1', '')
            localStorage.setItem('EduAdd', '')
            localStorage.setItem('pxAdd', '')
            localStorage.setItem('rmAdd', '')
            this.$router.push({
              name: 'EduInfojy',
              query: {
                id: item.id,
                cate: this.$route.query.id
              }
            })
          }
        } else {
          this.$message.success("请先登录再操作");
          // setTimeout(()=>{
          this.$router.push("/login");
          // },1000)
        }
      },
      toMoreInfo(item) {
        this.$router.push({
          name: 'InformationDetail',
          query: {
            id: item.id
          }
        })
      },

      toRecommend(id) {
        this.$router.push({
          name: 'CommonDetail',
          query: {
            id: id
          }
        })
      },
      findArea() {
        findArea({
          page: 1,
          limit: 3
        }).then(res => {
          if (res.data.code == 0) {
            let commonList = res.data.page.list
            commonList.forEach(item => {
              if (item.mainImage) {
                item.mainImage = process.env.VUE_APP_IMG_URL + item.mainImage
              }
            })
            this.commonList = commonList
            console.log('commonList', this.commonList)
          }
        })
      },
      nominateSwitch() {
        nominateSwitch({
          params: 1
        }).then(res => {
          if (res.data.code == 0) {
            let commonList = res.data.page.list
            commonList.forEach(item => {
              if (item.mainImage) {
                item.mainImage = process.env.VUE_APP_IMG_URL + item.mainImage
              }
            })
            this.commonList = commonList
            console.log('commonList', this.commonList)
          }
        })
      },
      toInform() {
        this.$router.push({
          name: 'Information'
        })
      },
      gateCount(startTime, endTime) {
        gateCount({
          "startTime": startTime,
          "endTime": endTime
        }).then(res => {
          if (res.data.code == 0) {
            this.peopleCount = res.data.data
          }
        })
      },
      //顶部轮播
      getHomePage() {
        getHomePage({
          type: 1,
          affiliation: 1
        }).then(res => {
          if (res.data.code == 0) {
            let carousel = res.data.list
            carousel.forEach(item => {
              if (item.url) {
                item.url = process.env.VUE_APP_IMG_URL + item.url
              }
            })
            this.carouselList = carousel
          }
        })
      },
      toCinema() {
        this.$router.push({
          name: 'Cinema'
        })
        // this.$message('暂未开放')
        // if (Cookies.get('userInfoqd')) {
        //   if (!JSON.parse(Cookies.get('userInfoqd')).token) {
        //     this.$message.success('请先登录再操作')
        //     setTimeout(() => {
        //       this.$router.push('/login')
        //     }, 1000)
        //   } else {
        //     // getMe().then(res=>{
        //     //   if(res.data.code=='0'){
        //     this.$router.push({
        //       name: 'Cinema'
        //     })
        //   }
        // } else {
        //   this.$message.success('请先登录再操作')
        //   setTimeout(() => {
        //     this.$router.push('/login')
        //   }, 1000)
        // }
      },
      toNotice(item) {
        this.$router.push({
          name: 'InformationDetail',
          query: {
            id: item.id
          }
        })
      },
      pageFilms() {
        pageFilms({
          page: 1,
          limit: this.pageSize
        }).then(res => {
          if (res.data.code == 0) {
            let filmList = res.data.page.list
            filmList.forEach(item => {
              item.posterImg = process.env.VUE_APP_IMG_URL + item.posterImg
              // film\\20220823\\d33e6094683a48f39709dec7c31f7622.png
            })
            this.filmList = filmList.slice(0,3)
            // this.hallId=this.cinemaList[0].id
            // this.pageFilmByHall(this.cinemaList[0].id)
          }
        })
      },
      gethall() {
        gethall({}).then(res => {
          if (res.data.code == 0) {
            this.cinemaList = res.data.data.slice(0,2)
            // this.hallId=this.cinemaList[0].id
            // this.pageFilmByHall(this.cinemaList[0].id)
          }
        })
      },
      //教育活动列表接口
      getActivityList(crowdId, typeId) {
        getActivityList({
          crowdId: crowdId,
          limit: JSON.stringify(this.pageSize5),
          needOrder: "1",
          page: JSON.stringify(this.page),
          typeId: typeId
        }).then(res => {
          if (res.data.code == 0) {
            let itemList = res.data.page.list
            itemList.forEach(item => {
              if (item.mainImg) {
                item.mainImg = process.env.VUE_APP_IMG_URL + item.mainImg
              }
            })
            this.activityList = itemList
            console.log(this.activityList)
            this.$nextTick(() => {
              var swiper = new Swiper('.swiper-container', {
                slidesPerView: 1,
                // autoplay:true,
                loop: true,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next2',
                  prevEl: '.swiper-button-prev2',
                },
              });
              let resizeEvent = document.createEvent('Event')
              resizeEvent.initEvent('resize', true, true)
              window.dispatchEvent(resizeEvent)
            })
          }
        })
      },
      toLink(url) {
        window.open(url)
      },
      getcontenconnecconfigure() {
        getcontenconnecconfigure().then(res => {
          let linkList = res.data.list
          linkList.forEach(item => {
            if (item.picture) {
              item.picture = process.env.VUE_APP_IMG_URL + item.picture
            }
          })
          this.linkList = linkList
        })
      },
      timeFormatDate(time) {
        var d = time ? new Date(time) : new Date();
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var hours = d.getHours();
        var min = d.getMinutes();
        var seconds = d.getSeconds();

        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;

        return (year + '-' + month + '-' + day + ' 00:00:00');
      },
      timeFormatSeconds(time) {
        var d = time ? new Date(time) : new Date();
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var hours = d.getHours();
        var min = d.getMinutes();
        var seconds = d.getSeconds();

        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        if (hours < 10) hours = '0' + hours;
        if (min < 10) min = '0' + min;
        if (seconds < 10) seconds = '0' + seconds;

        return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
      },
      getInformList(type) {
        getInformList({
          type: type,
          owningVenue:0
        }).then(res => {
          if (res.data.code == 0) {
            let infoList = res.data.informationList
            infoList = infoList.sort(function(a, b) {
              return new Date(b.createTime).getTime() - new Date(a.createTime).getTime()
            });
            infoList.forEach(item => {
              if (item.fileAddress) {
                item.fileAddress = process.env.VUE_APP_IMG_URL + item.fileAddress
              }
              item.createTime = this.timeFormatSeconds(item.createTime)
              let value = item.content
              value = value.replace(/(\n)/g, "");
              value = value.replace(/(\t)/g, "");
              value = value.replace(/(\r)/g, "");
              value = value.replace(/(&nbsp;)/g, "");
              value = value.replace(/<\/?[^>]*>/g, "");
              value = value.replace(/\s*/g, "");
              item.content = value
            })

            if (type == 0) {
              if (infoList.length > 2) {
                this.noticeList = infoList.slice(0, 2)
              }
            } else if (type == 1) {
              if (infoList.length > 3) {
                infoList = infoList.slice(0, 6)
              }
              this.infoList = infoList
            }
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: 'warning'
            // });
          }
        })
      },

      //内容管理
      getInfo() {
        getInfo().then(res => {
          if (res.data.code == 0) {
            this.contentInfo = res.data.contenfronpageManage
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: 'warning'
            // });
          }

        })
      },
      toVolunteer() {
        // this.$message('暂未开放')
        if (Cookies.get('userInfoqd')) {
          if (!JSON.parse(Cookies.get('userInfoqd')).token) {
            this.$message.success('请先登录再操作')
            setTimeout(() => {
              this.$router.push('/login')
            }, 1000)
          } else {
            this.$router.push({
              name: 'Volunteer'
            })
          }
        } else {
          this.$message.success('请先登录再操作')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        }
      },
      cEnter() {
        this.$nextTick(() => {
          this.knowAutoplay = false
        })
      },
      cLeave() {
        this.$nextTick(() => {
          this.knowAutoplay = true
        })
      },
      cEnterzx() {
        this.$nextTick(() => {
          this.knowAutoplayzx = false
        })
      },
      cLeavezx() {
        this.$nextTick(() => {
          this.knowAutoplayzx = true
        })
      },
      toAppoint(index) {
        if (Cookies.get('userInfoqd')) {
          if (!JSON.parse(Cookies.get('userInfoqd')).token) {
            this.$message.success('请先登录再操作')
            setTimeout(() => {
              this.$router.push('/login')
            }, 1000)
          } else {
            // getMe().then(res=>{
            //   if(res.data.code=='0'){
            if (index == 0) {
              this.$router.push({
                name: 'Self'
              })
            } else if (index == 1) {
              this.$router.push({
                name: 'Team'
              })
            } else if (index == 2) {
              this.$router.push({
                name: 'Cinema'
              })
            } else if (index == 3) {
              this.$router.push({
                name: 'EduInform'
              })
            }
            //   }else if(res.data.code=='403'){
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     setTimeout(()=>{
            //       this.$router.push('/login')
            //     },1000)
            //   }else{
            //     this.zhShow=1
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     setTimeout(()=>{
            //       this.$router.push('/login')
            //     },1000)
            //   }
            // })
          }
        } else {
          this.$message.success('请先登录再操作')
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000)
        }

      },
      // 鼠标滚动事件
      windowAddMouseWheel() {
        let that = this;
        var scrollFunc = function(e) {
          e = e || window.event;
          if (e.wheelDelta) {
            //判断浏览器IE，谷歌滑轮事件
            if (e.wheelDelta > 0) {
              //当滑轮向上滚动时
              that.down = 0
              if (that.activeClass) {
                that.size = parseInt(that.size) + 1
                // if(that.size>=150){
                //   that.size=150
                // }
              }

            } else if (e.wheelDelta < 0) {
              that.down = 1
              if (that.activeClass) {
                that.size = that.size - 1
                // if(that.size<=120){
                //   that.size=120
                // }
              }
            }
          } else if (e.detail) {
            //Firefox滑轮事件
            if (e.detail > 0) {
              //当滑轮向上滚动时
              that.down = 0
              if (that.activeClass) {
                that.size = parseInt(that.size) + 1
                // if(that.size>=150){
                //   that.size=150
                // }
              }
            } else if (e.detail < 0) {
              //当滑轮向下滚动时
              that.down = 1
              if (that.activeClass) {
                that.size = that.size - 1
                // if(that.size<=120){
                //   that.size=120
                // }
              }
            }
          }
        };
        //给页面绑定滑轮滚动事件
        if (document.addEventListener) {
          //火狐使用DOMMouseScroll绑定
          document.addEventListener("DOMMouseScroll", scrollFunc, false);
        }
        //其他浏览器直接绑定滚动事件
        window.onmousewheel = document.onmousewheel = scrollFunc;
      },
      toScroll() {
        if (document.getElementsByClassName('scrollContent1')[0].getBoundingClientRect().top < 10) {
          this.activeClass1 = true
        }
      },
      handleScroll() {
        // console.log('aaa')
        let val = document.getElementsByClassName('wrap')[0].getBoundingClientRect().top
        let val1 = document.getElementsByClassName('scrollContent15')[0].getBoundingClientRect().top
        let val2 = document.getElementsByClassName('scrollContent1')[0].getBoundingClientRect().bottom
        if (val < 20) {
          this.downto = 1
          this.activeClass = true
          if (val2 < parseInt(document.body.clientHeight) + 20) {
            this.activeClass = false
          } else {
            this.activeClass = true
          }
        } else {
          this.downto = 0
          this.activeClass = false
        }

      },
      // getElemDis(el) {
      //     var tp = document.documentElement.clientTop,
      //         lt = document.documentElement.clientLeft,
      //         rect = el.getBoundingClientRect();
      //         console.log(tp)
      //     return {
      //         top: rect.top - tp,
      //         right: rect.right - lt,
      //         bottom: rect.bottom - tp,
      //         left: rect.left - lt
      //     }
      // },
      throttleHandleScroll() {

      },
      enter() {
        // let obj=document.getElementsByClassName('text')[0]
        clearInterval(this.timer1)
        this.timer1 = null
      },
      leave() {
        const content = document.querySelector('.content')
        const text = document.querySelector('.text')
        console.log(content.clientWidth, content.scrollWidth, text.offsetWidth)
        this.timer1 = setInterval(() => {
          content.scrollLeft++
          if (content.clientWidth + content.scrollLeft >= /*content.scrollWidth*/ text.offsetWidth) {
            content.scrollLeft = 0
          }
        }, 20);
      },
      openTip() {

      },
      changeCarousel(a) {
        if (this.carouselList.length == 2) {
          a === 2 ? this.indexActive = 0 : a === 3 ? this.indexActive = 1 : this.indexActive = a
        } else {
          this.indexActive = a
        }
      },
      handleCarousel(index) {
        this.$refs.carouselTax.setActiveItem(index)
      },

      // 新闻资讯
      changeCarouselNews(a) {
        if (this.commonList.length == 2) {
          a === 2 ? this.indexActive = 0 : a === 3 ? this.indexActive = 1 : this.indexActive = a
        } else {
          this.indexActive = a
        }
      },
      handleCarouselNews(index) {
        // if(index==0){
        //   this.indexActive=this.indexActive-1
        // }else{
        //   this.indexActive=this.indexActive+1
        // }
        // this.$refs.carouselTaxNews1.setActiveItem(index)
        if (index == 0) {
          this.$refs.carouselTaxNews1.prev()
        } else {
          this.$refs.carouselTaxNews1.next()
        }
      },
      // 新闻资讯
      changeCarouselNewsn(a) {
        if (this.infoList.length == 2) {
          a === 2 ? this.indexActiven = 0 : a === 3 ? this.indexActiven = 1 : this.indexActiven = a
        } else {
          this.indexActiven = a
        }
      },

      handleCarouselNewsn(index) {
        this.$refs.carouselTaxNewsn.setActiveItem(index)
        this.$refs.carouselTaxNews1n.setActiveItem(index)
      },

      // 新闻资讯
      changeCarouselEdu(a) {
        if (this.activityList.length == 2) {
          this.indexActivej = a
          // a===2?this.indexActive=0:a===3?this.indexActive = 1:this.indexActive=a
        } else {
          this.indexActivej = a
        }
      },
      handleCarouselEdu(index) {
        this.$refs.carouselTaxEdu.setActiveItem(index)
      },
    },
  }
</script>
<style>
  .happy-scroll-content {
    width: 100%;
    border-bottom: none !important;
    border-top: none !important;
    border-right: none !important;
  }

  *::-webkit-scrollbar {
    display: none;
  }

  * {
    scrollbar-width: none;
  }

  * {
    -ms-overflow-style: none;
  }

  /*  .happy-scroll-strip--vertical .happy-scroll-bar{
    opacity: 1!important;
  } */
  .happy-scroll-strip--vertical {
    z-index: 7000;
    background: #fff
  }

  .happy-scroll-strip--vertical .happy-scroll-bar {
    background: #fff;
    box-shadow: 1px;
  }

  .happy-scroll-strip--horizontal .happy-scroll-bar {
    border-radius: 7px;
    background: #fff;
    height: 6px !important;
    width: 0;
    -webkit-transition: height 0.4s ease, width 0.6s ease;
    transition: height 0.4s ease, width 0.6s ease;
  }

  .happy-scroll-container {
    height: 100% !important;
  }

  .happy-scroll-container {
    width: 100% !important;
  }

  .el-message.el-message--error {
    z-index: 5000 !important;
  }

  .el-message.el-message--warning {
    z-index: 5000 !important;
  }

  .el-time-panel.el-popper {
    z-index: 5000 !important;
  }

  .el-select-dropdown.el-popper {
    z-index: 5000 !important;
  }
</style>
<style lang="less" scoped>
  .kjggkSty p {
    background-color: red;
  }

  .tdAppoint {
    z-index: 5000 !important;

    /deep/ .el-input-number__increase {
      width: 0;
      border: none !important;

      .el-icon-arrow-up:before {
        font-size: 0;
      }
    }

    /deep/ .el-input-number__decrease {
      width: 0;
      border: none !important;

      .el-icon-arrow-down:before {
        font-size: 0;
      }
    }

    /deep/ .el-input-number__increase1 {
      cursor: pointer;
      position: absolute;
      top: 30% !important;
      right: 0.375rem;
      display: flex;
      z-index: 3000;
      width: 0.2125rem;
      height: 0.125rem !important;
      border-left: none !important;
      border-bottom: none !important;

      .el-icon-arrow-up {
        width: 0.2125rem;
        height: 0.125rem !important;
      }

      .el-icon-arrow-up:before {
        width: 0.2125rem;
        height: 0.125rem !important;
        background: url(../teamAppoint/image/teamUp.png) no-repeat;
        background-size: 0.2125rem 0.125rem;
        // background-position: 0% 100%;
        color: transparent;
        cursor: pointer;
        display: inline-block;
      }

    }

    /deep/ .el-input-number__decrease1 {
      cursor: pointer;
      position: absolute;
      top: 60% !important;
      right: 0.375rem;
      z-index: 3000;
      display: flex;
      border-left: none !important;
      width: 0.2125rem;
      height: 0.125rem !important;

      .el-icon-arrow-down {
        width: 0.2125rem;
        height: 0.125rem !important;
      }

      .el-icon-arrow-down:before {
        width: 0.2125rem;
        height: 0.125rem !important;
        background: url(../teamAppoint/image/teamDown.png) no-repeat;
        background-size: 0.2125rem 0.125rem;
        color: transparent;
        cursor: pointer;
        display: inline-block;
      }
    }

    // .ylActive{
    //   /deep/ .el-input-number__increase{
    //     display: none;
    //   }
    //   /deep/ .el-input-number__decrease{
    //     display: none;
    //   }
    // }
    /deep/ input::-webkit-outer-spin-button,
    /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: true !important;
    }

    /deep/ input[type='number'] {
      -moz-appearance: textfield !important;
    }

    /deep/ .el-form-item__content {
      margin-left: 2.9rem !important;
    }

    .el-input-number {
      width: 100% !important;
      position: relative;

      /deep/ .el-input__inner {
        text-align: left !important;
        padding-right: 0;
        width: 100%;
      }
    }

    .el-input-number.is-controls-right {
      box-sizing: border-box;
    }

    .teamSty {
      width: 100%;
      padding: 0 3rem;
      box-sizing: border-box;
    }

    .teamTitle {
      text-align: center;
      font-size: 0.35rem;
      font-weight: bold;
      color: #333333;
      margin-top: 0.7rem;
      margin-bottom: 0.4625rem;
    }

    .teamTitle1 {
      font-size: 0.225rem;
      font-weight: bold;
      line-height: 0.6rem;
      color: #333333;
    }

    .teamContent {
      font-size: 0.225rem;
      color: #333333;
      line-height: 0.5rem;
    }

    /deep/ .el-dialog {
      width: 15.5rem !important;
      min-height: 11rem;
      background: #FFFFFF;
      border-radius: 0.125rem;
      margin-top: 1vh !important;
    }

    /deep/ .el-dialog__title {
      font-size: 0.35rem;
      font-weight: bold;
      color: #333333;
    }

    /deep/ .el-dialog__header {
      padding-top: 0.5625rem;
    }

    .cancelBut.el-button {
      width: 2.5rem;
      height: 0.85rem;
      border: 0.0125rem solid #3C7CFF;
      border-radius: 0.425rem;
      font-size: 0.3rem;
      color: #3C7CFF;
      line-height: 0.85rem;
      padding: 0;
    }

    .confirmBut.el-button {
      width: 2.5rem;
      height: 0.85rem;
      background: #3C7CFF;
      border-radius: 0.425rem;
      font-size: 0.3rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 0.85rem;
      padding: 0;
      border: none;
      margin-left: 0.875rem;
    }

    .confirmBut.el-button:active {
      box-shadow: inset 0px 0px 3px 3px #214fad;
    }

    /deep/ .el-dialog--center .el-dialog__body {
      text-align: center;
      padding-bottom: 0.25rem;
      font-size: 0.35rem;
      color: #333333;
    }

    #homePage {
      min-height: 100vh;
    }

    .appointTitle {
      position: relative;
      font-size: 0.3rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      padding-left: 0.125rem;
    }

    .appointTitle:before {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%);
      content: '';
      width: 0.05rem;
      height: 0.25rem;
      background: #3C7CFF;
      border-radius: 0.025rem;
    }

    .dateStyw {
      margin-right: 0.6rem;
      margin-bottom: 0.25rem;
      flex: 0 0 2.4375rem;
      width: 2.4375rem;
      height: 1.325rem;
    }

    .dateSty {
      color: #333333;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 0.15rem 0;
      box-sizing: border-box;
      justify-content: center;
      border: 0.025rem solid #E5E5E5;
      border-radius: 0.0625rem;
      flex: 0 0 2.4375rem;
      width: 2.4375rem;
      height: 1.325rem;
    }

    .dateSty1 {
      flex: 1;
      font-size: 0.3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      ;
      justify-content: center;
    }

    .timeSty {
      display: flex;
      flex-wrap: wrap;
    }

    .timeSty1 {
      cursor: pointer;
      margin-bottom: 0.25rem;
      flex: 0 0 3.5rem;
      text-align: center;
      margin-right: 0.375rem;
      width: 3.5rem;
      height: 0.75rem;
      line-height: 0.75rem;
      border: 0.025rem solid #E5E5E5;
      border-radius: 0.0625rem;
      font-size: 0.3rem;
    }

    .timeActive {
      background: rgba(238, 86, 79, 0.1000);
      border-color: #3C7CFF;
      color: #3C7CFF;
    }

    .nextBut {
      margin-top: 1.875rem;
      margin-bottom: 1.25rem;
    }

    .nextBut .el-button {
      width: 3.75rem;
      height: 0.975rem;
      line-height: 0.975rem;
      background: #5C5DF6;
      border-radius: 0.05rem;
      font-size: 0.3rem;
      text-align: center;
      font-weight: bold;
      color: #FFFFFF;
      padding: 0;
      border: none;
    }

    .nextBut .el-button:active {
      box-shadow: inset 0px 0px 3px 3px #214fad;
    }

    .selfBut .el-button {
      width: 1.925rem;
      height: 0.6375rem;
      line-height: 0.6375rem;
      padding: 0;
      background: #3C7CFF;
      border-radius: 0.0875rem;
      font-size: 0.25rem;
      color: #FFFFFF;
      border: none;
    }

    .selfBut .el-button:active {
      box-shadow: inset 0px 0px 2px 2px #214fad;
    }

    .selfBut .el-form-item {
      height: 0.925rem;
      line-height: 0.925rem;
    }

    .selfBut1 .el-form-item {
      float: right;
    }

    .selfBut /deep/ .el-form-item__label {
      height: 0.925rem;
      line-height: 0.925rem;
      text-align: right;
      font-size: 0.275rem;
      width: 2.4rem !important;
    }

    .selfBut2 /deep/ .el-form-item__label {
      width: 2rem !important;
    }

    .selfBut2 /deep/ .el-form-item__content {
      margin-left: 2.5rem !important;
      text-align: left;
    }

    .selfBut /deep/ .el-input__inner {
      width: 4rem;
      height: 0.925rem;
      background: #F5F8FC;
      color: #000;
      // border: 1px solid #EE564F;
      border-radius: 0.0875rem;
      font-size: 0.275rem;
    }

    .addSty .el-button {
      width: 1.925rem;
      height: 0.6375rem;
      background: #3C7CFF;
      border-radius: 0.0875rem;
      font-size: 0.25rem;
      color: #FFFFFF;
      line-height: 0.6375rem;
      padding: 0;
    }

    .prevStep.el-button {
      width: 3.75rem;
      height: 0.975rem;
      border: 0.0125rem solid #3C7CFF;
      border-radius: 0.05rem;
      font-size: 0.3rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #3C7CFF;
      line-height: 0.975rem;
      padding: 0;
      // margin-top: 1.75rem;
    }

    .submitStep.el-button {
      width: 3.75rem;
      height: 0.975rem;
      padding: 0;
      line-height: 0.975rem;
      background: #3C7CFF;
      border-radius: 0.05rem;
      font-size: 0.3rem;
      font-weight: bold;
      color: #FFFFFF;
      // margin-top: 1.75rem;
      border: none;
    }

    .submitStep.el-button:active {
      box-shadow: inset 0px 0px 3px 3px #214fad;
    }

    .prevStep1.el-button {
      width: 3.75rem;
      height: 0.975rem;
      border: 0.0125rem solid #3C7CFF;
      border-radius: 0.05rem;
      font-size: 0.3rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #3C7CFF;
      line-height: 0.975rem;
      padding: 0;
      margin-top: 1.75rem;
    }

    .submitStep1.el-button {
      width: 3.75rem;
      height: 0.975rem;
      padding: 0;
      line-height: 0.975rem;
      background: #3C7CFF;
      border-radius: 0.05rem;
      font-size: 0.3rem;
      font-weight: bold;
      color: #FFFFFF;
      margin-top: 1.75rem;
      border: none;
    }

    .butStym /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .selfDiag /deep/ .el-dialog {
    width: 8.125rem !important;
    height: 7.975rem;
    background: #FFFFFF;
    border-radius: 0.125rem;
  }

  /deep/ .el-dialog__wrapper.selfDiag {
    overflow: hidden;
    z-index: 4002 !important;
    // position: relative;
  }

  .selfDiag /deep/ .el-dialog__title {
    font-size: 0.35rem;
    font-weight: bold;
    color: #333333;
  }

  .selfDiag /deep/ .el-dialog__header {
    padding-top: 0.5625rem;
  }

  .selfDiag .cancelBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    border: 0.0125rem solid #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    color: #3C7CFF;
    line-height: 0.85rem;
    padding: 0;
  }

  .selfDiag .confirmBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    background: #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.85rem;
    padding: 0;
    border: none;
    margin-left: 0.875rem;
  }

  .selfDiag .confirmBut.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
  }

  .selfDiag /deep/ .el-dialog--center .el-dialog__body {
    text-align: center;
    padding-bottom: 0.25rem;
    font-size: 0.35rem;
    color: #333333;
  }

  .yzmDiag /deep/ .el-dialog--center .el-dialog__body {
    text-align: center;
    font-size: 0.35rem;
    color: #333333;
  }

  /deep/ .el-dialog__wrapper.yzmDiag {
    overflow: hidden;
    z-index: 4002 !important;
    // position: relative;
  }

  .yzmDiag /deep/ .el-dialog {
    width: 8.125rem !important;
    height: 5.5rem;
    background: #FFFFFF;
    border-radius: 0.125rem;
  }

  .yzmDiag /deep/ .el-dialog__title {
    font-size: 0.35rem;
    font-weight: bold;
    color: #333333;
  }

  .yzmDiag /deep/ .el-dialog__header {
    padding-top: 0.5625rem;
  }

  .yzmDiag .cancelBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    border: 0.0125rem solid #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    color: #3C7CFF;
    line-height: 0.85rem;
    padding: 0;
  }

  .yzmDiag .confirmBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    background: #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.85rem;
    padding: 0;
    border: none;
    margin-left: 0.875rem;
  }

  .yzmDiag .confirmBut.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
  }

  .yzmDiag /deep/ .el-dialog--center .el-dialog__body {
    text-align: center;
    padding-bottom: 0.25rem;
    font-size: 0.35rem;
    color: #333333;
  }

  .yzmDiag /deep/ .el-input__inner {
    width: 6.15rem;
    height: 0.85rem;
    background: #F5F8FC;
    border-radius: 0.075rem;
    box-sizing: border-box;
  }

  .middleCircle {
    display: inline-block;
    margin-right: 0.1125rem;
    width: 0.125rem;
    height: 0.125rem;
    background: #DCDCDC;
    border-radius: 50%;
  }

  .selfBut {}

  .selfBut .el-button {
    width: 1.925rem;
    height: 0.6375rem;
    line-height: 0.6375rem;
    padding: 0;
    background: #3C7CFF;
    border-radius: 0.0875rem;
    font-size: 0.25rem;
    color: #FFFFFF;
    border: none;
  }

  .selfBut .el-button:active {
    box-shadow: inset 0px 0px 2px 2px #214fad;
  }

  .selfBut .el-form-item {
    height: 0.925rem;
    line-height: 0.925rem;
  }

  .selfBut /deep/ .el-form-item__label {
    height: 0.925rem;
    line-height: 0.925rem;
    text-align: left;
    font-size: 0.275rem;
    width: 1.5rem !important;
  }

  .selfBut /deep/ .el-input__inner {
    width: 4rem;
    height: 0.925rem;
    background: #F5F8FC;
    color: #000;
    // border: 1px solid #EE564F;
    border-radius: 0.0875rem;
    font-size: 0.275rem;
  }

  .appointTitle {
    position: relative;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    padding-left: 0.125rem;
  }

  .appointTitle:before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    content: '';
    width: 0.05rem;
    height: 0.25rem;
    background: #3C7CFF;
    border-radius: 0.025rem;
  }

  .dateStyw {
    margin-right: 0.4rem;
    margin-bottom: 0.15rem;
    flex: 0 0 2.4375rem;
    width: 2.4375rem;
    height: 1.325rem;
  }

  .dateSty {
    color: #333333;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0.15rem 0;
    box-sizing: border-box;
    justify-content: center;
    border: 0.025rem solid #E5E5E5;
    border-radius: 0.0625rem;
    flex: 0 0 2.4375rem;
    width: 2.4375rem;
    height: 1.325rem;
  }

  .dateSty1 {
    flex: 1;
    font-size: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    ;
    justify-content: center;
  }

  .timeSty {
    display: flex;
    flex-wrap: wrap;
    min-height: 1.175rem;
  }

  .timeSty1 {
    cursor: pointer;
    margin-bottom: 0.25rem;
    flex: 0 0 3.5rem;
    text-align: center;
    margin-right: 0.375rem;
    width: 3.5rem;
    height: 0.75rem;
    line-height: 0.75rem;
    border: 0.025rem solid #E5E5E5;
    border-radius: 0.0625rem;
    font-size: 0.3rem;
  }

  .timeActive {
    background: rgba(60, 124, 255, 0.1);
    border-color: #3C7CFF;
    color: #3C7CFF;
  }

  // .nextBut{
  //   margin-top: 1.275rem;
  //   margin-bottom: 1.25rem;
  // }
  // .nextBut .el-button{
  //   width: 3.75rem;
  //   height: 0.975rem;
  //   line-height: 0.975rem;
  //   background: #5C5DF6;
  //   border-radius: 0.05rem;
  //   font-size: 0.3rem;
  //   text-align: center;
  //   font-weight: bold;
  //   color: #FFFFFF;
  //   padding: 0;
  //   border: none;
  // }
  // .nextBut .el-button:active{
  //   box-shadow: inset 0px 0px 3px 3px #3f3fad;
  // }
  .nextBut.el-button {
    width: 3.75rem;
    height: 0.975rem;
    line-height: 0.975rem;
    background: #3C7CFF;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    text-align: center;
    font-weight: bold;
    color: #FFFFFF;
    padding: 0;
    border: none;
    margin-top: 0.2rem;
  }

  .nextBut.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
  }

  .prevStep.el-button {
    width: 3.75rem;
    height: 0.975rem;
    background: #FFFFFF;
    border: 1px solid #3C7CFF;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    font-weight: bold;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3C7CFF;
    line-height: 0.975rem;
    padding: 0;
  }

  .submitStep.el-button {
    width: 3.75rem;
    height: 0.975rem;
    background: #3C7CFF;
    border-radius: 0.05rem;
    border: none;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.975rem;
    padding: 0;
  }

  .submitStep.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
  }

  .prevStep1.el-button {
    width: 3.75rem;
    height: 0.975rem;
    border: 0.0125rem solid #5C5DF6;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #5C5DF6;
    line-height: 0.975rem;
    padding: 0;
    margin-top: 1.75rem;
  }

  .submitStep1.el-button {
    width: 3.75rem;
    height: 0.975rem;
    padding: 0;
    line-height: 0.975rem;
    background: #5C5DF6;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 1.75rem;
    border: none;
  }

  .butStym /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .selfDiaguis .el-date-editor {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .selfDiaguis /deep/ .el-icon-date {
    margin-left: 10px;
  }

  .selfDiaguis .el-select {
    width: 100%;
  }

  .selfDiaguis /deep/ .el-dialog__footer {
    // padding-top: 0.775rem!important;
    // padding-bottom: 0.5rem!important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .selfDiaguis /deep/ .el-form-item__label {
    width: 2.3rem !important;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: left;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
  }

  .selfDiaguis /deep/ .el-form-item {
    width: 6.35rem !important;
    // margin-bottom: 0.65rem;
  }

  .selfDiaguis /deep/ .el-input-number__decrease {
    border-color: transparent !important;
    width: 0.75rem;
    height: 0.5rem;
    border-radius: 0.0625rem;
    color: RGBA(216, 213, 216, 1);
    border: 0.0125rem solid RGBA(216, 213, 216, 1) !important;
    background-color: transparent;

  }

  .selfDiaguis /deep/ .el-input-number__increase {
    border-color: transparent !important;
    width: 0.75rem;
    height: 0.5rem;
    line-height: 0.5rem;
    border-radius: 0.0625rem;
    font-size: 0.3125rem;
    font-weight: bold;
    background-color: #323232;
    padding: 0;
    color: #fff;
  }

  .selfDiaguis /deep/ .el-input {
    color: #323232;
    font-size: 0.35rem;
  }

  .selfDiaguis /deep/ .el-input-number {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  .selfDiaguis /deep/ .el-input__inner {
    border-color: transparent !important;
  }

  .selfDiaguis /deep/ .el-input-number__increase:active {
    // box-shadow: inset 0px 0px 3px 3px #cf4a44;
  }

  .selfDiaguis /deep/ .el-form-item__content {
    width: 4.05rem;
    margin-left: 0 !important;
    height: 0.8rem;
    line-height: 0.8rem;
    display: flex;
    border-bottom: 1px solid #F3F3F3;
    ;
  }

  .selfDiaguis /deep/ .el-input {
    color: #323232;
    font-size: 0.275rem;
  }

  .selfDiaguis /deep/ .el-input-number {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  .selfDiaguis /deep/ .el-input__inner {
    border-color: transparent !important;
  }

  .selfDiaguis /deep/ .el-input-number__decrease {
    // border-color: transparent!important;
    // width: 0.75rem;
    // height: 0.5rem;
    // border-radius: 0.0625rem;
    // color: RGBA(216, 213, 216, 1);
    // border: 0.0125rem solid RGBA(216, 213, 216, 1)!important;
    // background-color:transparent;

  }

  .selfDiaguis /deep/ .el-input-number__increase {
    // border-color: transparent!important;
    // width: 0.75rem;
    // height: 0.5rem;
    // border-radius: 0.0625rem;
    // background-color: RGBA(237, 82, 80, 1);
    // padding: 0;
    // color: #fff;
  }

  .selfDiaguis /deep/ .el-input__inner {
    padding: 0;
  }

  .selfDiaguis /deep/ .el-input-number .el-input__inner {
    // text-align: left;
  }

  .selfDiaguis /deep/ .el-input-number__increase:active {
    // box-shadow: inset 0px 0px 3px 3px #cf4a44;
  }

  .selfDiaguis /deep/ .el-dialog {
    width: 15.5rem !important;
    height: 10rem;
    padding: 0 0.7875rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 0px 0.25rem 0px rgba(0, 0, 0, 0.25);
    border-radius: 0.075rem;
    margin-top: 3vh !important;
  }

  .selfDiaguis1t /deep/ .el-dialog {
    width: 15.5rem !important;
    height: 11rem;
    padding: 0 0.7875rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 0px 0.25rem 0px rgba(0, 0, 0, 0.25);
    border-radius: 0.075rem;
    margin-top: 3vh !important;
  }

  /deep/ .el-dialog__wrapper.selfDiaguis {
    overflow: hidden;
    z-index: 4002 !important;
    // position: relative;
  }

  .selfDiaguis /deep/ .el-dialog__title {
    font-size: 0.35rem;
    font-weight: bold;
    color: #333333;
  }

  .selfDiaguis /deep/ .el-dialog__header {
    padding-top: 0.525rem;
    padding-bottom: 0.3375rem;
    // border-bottom: 0.0125rem solid #DCDCDC;
  }

  .selfDiaguis .cancelBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    border: 0.0125rem solid #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    color: #3C7CFF;
    line-height: 0.85rem;
    padding: 0;
  }

  .selfDiaguis .confirmBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    background: #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.85rem;
    padding: 0;
    border: none;
    margin-left: 0.875rem;
  }

  .selfDiaguis /deep/ .el-dialog--center .el-dialog__body {
    text-align: center;
    font-size: 0.35rem;
    color: #333333;
    padding: 0 !important;
    // padding: 0.6rem 0.75rem 0 0.75rem;
    box-sizing: border-box;

  }

  .selfDiaguis /deep/ .el-dialog__headerbtn {
    position: absolute;
    top: 0.525rem;
    right: 0.625rem;

    .el-icon-close {
      font-size: 0.375rem;
      font-weight: bold;
    }
  }

  .selfDiaguis /deep/ .happy-scroll-container {
    height: 100% !important;

  }

  .selfDiaguis /deep/ .happy-scroll-content {
    padding: 0 0.25rem !important;
    width: auto !important;
  }

  .selfDiaguis1 /deep/ .happy-scroll-content {
    width: 100% !important;
    padding: 0 !important;
  }

  .selfDiaguis .confirmBut.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
    ;
  }




  .selfDiaguis2 .el-date-editor {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .selfDiaguis2 /deep/ .el-icon-date {
    margin-left: 10px;
  }

  .selfDiaguis2 .el-select {
    width: 100%;
  }

  .selfDiaguis2 /deep/ .el-dialog__footer {
    // padding-top: 0.775rem!important;
    // padding-bottom: 0.5rem!important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .selfDiaguis2 /deep/ .el-form-item__label {
    width: 1.5rem !important;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: left;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
  }

  .selfDiaguis2 /deep/ .el-form-item {
    width: 6.35rem !important;
    // margin-bottom: 0.65rem;
  }

  .selfDiaguis2 /deep/ .el-input-number__decrease {
    border-color: transparent !important;
    width: 0.75rem;
    height: 0.5rem;
    border-radius: 0.0625rem;
    color: RGBA(216, 213, 216, 1);
    border: 0.0125rem solid RGBA(216, 213, 216, 1) !important;
    background-color: transparent;

  }

  .selfDiaguis2 /deep/ .el-input-number__increase {
    border-color: transparent !important;
    width: 0.75rem;
    height: 0.5rem;
    line-height: 0.5rem;
    border-radius: 0.0625rem;
    font-size: 0.3125rem;
    font-weight: bold;
    background-color: #323232;
    padding: 0;
    color: #fff;
  }

  .selfDiaguis2 /deep/ .el-input {
    color: #323232;
    font-size: 0.35rem;
  }

  .selfDiaguis2 /deep/ .el-input-number {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  .selfDiaguis2 /deep/ .el-input__inner {
    border-color: transparent !important;
  }

  .selfDiaguis2 /deep/ .el-input-number__increase:active {
    // box-shadow: inset 0px 0px 3px 3px #cf4a44;
  }

  .selfDiaguis2 /deep/ .el-form-item__content {
    width: 4.05rem;
    margin-left: 0 !important;
    height: 0.925rem;
    line-height: 0.925rem;
    display: flex;
    border-bottom: 1px solid #F3F3F3;
    ;
  }

  .selfDiaguis2 /deep/ .el-input {
    color: #323232;
    font-size: 0.275rem;
  }

  .selfDiaguis2 /deep/ .el-input-number {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  .selfDiaguis2 /deep/ .el-input__inner {
    border-color: transparent !important;
  }

  .selfDiaguis2 /deep/ .el-input-number__decrease {
    // border-color: transparent!important;
    // width: 0.75rem;
    // height: 0.5rem;
    // border-radius: 0.0625rem;
    // color: RGBA(216, 213, 216, 1);
    // border: 0.0125rem solid RGBA(216, 213, 216, 1)!important;
    // background-color:transparent;

  }

  .selfDiaguis2 /deep/ .el-input-number__increase {
    // border-color: transparent!important;
    // width: 0.75rem;
    // height: 0.5rem;
    // border-radius: 0.0625rem;
    // background-color: RGBA(237, 82, 80, 1);
    // padding: 0;
    // color: #fff;
  }

  .selfDiaguis2 /deep/ .el-input__inner {
    padding: 0 0.25rem;
  }

  .selfDiaguis2 /deep/ .el-input-number .el-input__inner {
    // text-align: left;
  }

  .selfDiaguis2 /deep/ .el-input-number__increase:active {
    // box-shadow: inset 0px 0px 3px 3px #cf4a44;
  }

  .selfDiaguis2 /deep/ .el-dialog {
    width: 15.5rem !important;
    height: 10.5rem;
    padding: 0 0.7875rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 0px 0.25rem 0px rgba(0, 0, 0, 0.25);
    border-radius: 0.075rem;
    margin-top: 3vh !important;
  }

  /deep/ .el-dialog__wrapper.selfDiaguis2 {
    overflow: hidden;
    z-index: 4002 !important;
    // position: relative;
  }

  .selfDiaguis2 /deep/ .el-dialog__title {
    font-size: 0.35rem;
    font-weight: bold;
    color: #333333;
  }

  .selfDiaguis2 /deep/ .el-dialog__header {
    padding-top: 0.525rem;
    padding-bottom: 0.7rem;
    // border-bottom: 0.0125rem solid #DCDCDC;
  }

  .selfDiaguis2 .cancelBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    border: 0.0125rem solid #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    color: #3C7CFF;
    line-height: 0.85rem;
    padding: 0;
  }

  .selfDiaguis2 .confirmBut.el-button {
    width: 2.5rem;
    height: 0.85rem;
    background: #3C7CFF;
    border-radius: 0.425rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.85rem;
    padding: 0;
    border: none;
    margin-left: 0.875rem;
  }

  .selfDiaguis2 /deep/ .el-dialog--center .el-dialog__body {
    text-align: center;
    font-size: 0.35rem;
    color: #333333;
    padding: 0 !important;
    // padding: 0.6rem 0.75rem 0 0.75rem;
    box-sizing: border-box;

  }

  .selfDiaguis2 /deep/ .el-dialog__headerbtn {
    position: absolute;
    top: 0.525rem;
    right: 0.625rem;

    .el-icon-close {
      font-size: 0.375rem;
      font-weight: bold;
    }
  }

  .selfDiaguis2 /deep/ .happy-scroll-container {
    height: 100% !important;

  }

  .selfDiaguis2 /deep/ .happy-scroll-content {
    // padding: 0 0.25rem!important;
    width: 100% !important;
  }

  .selfDiaguis2 .confirmBut.el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
    ;
  }

  .selfDiaguis2 .addSty .el-button {
    width: 1.25rem;
    height: 0.625rem;
    background: #3C7CFF;
    border-radius: 0.0875rem;
  }

  .selfDiaguis2 .addSty .el-button:active {
    box-shadow: inset 0px 0px 3px 3px #214fad;
    ;
  }



  .kjggkSty {
    width: 20.025rem;
    height: 5.525rem;
    margin: 0 auto;
    background-image: url('./image/kjk.png');
    background-size: 100% 100%;
    padding: 0.8rem 0.5rem 0.7rem 0.5rem;

    .el-button {
      padding: 0;
      width: 0.475rem;
      height: 0.475rem;
      line-height: 0.475rem;
      border: 0.0125rem solid #D2D2D2;
      border-radius: 0.075rem;
      color: #2498FC;
      font-weight: bold;
      font-size: 0.325rem;

      /deep/ .el-icon-arrow-right {
        font-weight: bold;
      }
    }
  }

  .qdMiddlew {
    position: relative;
    margin-top: -1.5625rem;
    z-index: 2000;
  }

  .qzxwSty {
    .el-button {
      padding: 0;
      width: 0.3375rem;
      height: 0.3375rem;
      border: 0.0125rem solid #D2D2D2;
      border-radius: 0.075rem;
      color: #2498FC;
      font-weight: bold;

      /deep/ .el-icon-arrow-right {
        font-weight: bold;
      }
    }
  }

  .qdMiddle {
    width: 19.725rem;
    height: 3.125rem;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
  }

  .qdMiddle1 {
    flex: 0 0 19rem;
    width: 19rem;
    height: 3.125rem;
    background: #FFFFFF;
    padding: 0.2375rem 0.375rem 0 0.625rem;
    box-sizing: border-box;
    box-shadow: 0px 0px 0.2375rem 0.0125rem rgba(0, 0, 0, 0.2);
  }

  .qdMiddle2 {
    display: flex;
    flex: 0 0 7.7rem;
    width: 7.7rem;
    height: 3.125rem;

    .qdMiddle21 {
      // flex: 0 0 1.925rem;
      width: 1.925rem;
      height: 3.125rem;
      background: #fff;
      background-image: url('./image/yybg1.png');
      background-size: 100% 100%;
      overflow: hidden;
      transition: all ease 0.1s;
    }

    .qdMiddle21Active {
      width: 2.25rem;
      margin-left: -0.1625rem;
      margin-top: -0.25rem;
      height: 3.625rem;
      background: #fff;
      background-image: url('./image/yybg2.png');
      background-size: 100% 100%;
      border-radius: 0.075rem;

      .txt1 {
        margin-top: 0.625rem !important;
        margin-bottom: 0.2875rem !important;
        font-size: 0.3rem !important;
        font-family: Microsoft YaHei;
        font-weight: bold !important;
        color: #FFFFFF !important;
        text-shadow: 0px 0px 0.125rem rgba(21, 118, 228, 0.45) !important;
      }

      .txt2 {
        font-size: 0.225rem !important;
        font-family: Microsoft YaHei !important;
        font-weight: 400 !important;
        color: #FFFFFF !important;
      }

      .img3 {
        width: 2.25rem !important;
        height: 2.25rem !important;
      }

      .img3div {
        margin-top: 0.5rem !important;
      }
    }
  }

  .qdTop {
    width: 100%;
    height: 12.125rem;
    background-image: url('./image/qdbanner.png');
    background-size: 100% 100%;
    background-origin: 0 0;
    position: relative;
  }

  .lineSty {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.5);
  }

  .bg-img {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background: url(./image/cinema.png) no-repeat center/150% 150%;
    -webkit-transition: all .3;
    transition: all .3;
  }

  .bg-img1 {
    pointer-events: none;
    position: absolute;
    top: 20.425rem;
    left: 0;
    right: 0;
    height: 100vh;
    // background: url(./image/cinema.png) no-repeat center/120% 120%;
    -webkit-transition: all .3;
    transition: all .3;
  }

  .isFixed {
    position: fixed;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .sybt {
    position: relative;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
    text-align: center;
    margin-top: 0.95rem;
  }

  .sybt::before,
  .sybt::after {
    content: '';
    /*CSS伪类用法*/
    position: absolute;
    /*定位背景横线的位置*/
    top: 50%;
    transform: translate(0, -50%);
    background: #AAAAAA;
    /*宽和高做出来的背景横线*/
    width: 0.625rem;
    height: 0.025rem;
  }

  .sybt::before {
    left: calc(50% - 1.5rem);
  }

  .sybt::after {
    right: calc(50% - 1.5rem);
  }

  .wholeSwiper {
    .swiper-container {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      margin-left: auto;
      margin-right: auto;
    }

    .swiper-button-prev {
      top: 50%;
      transform: translate(0, -50%);
      width: 0.75rem;
      height: 1.875rem;
      background: #D2D2D2;
      border-radius: 0.0375rem;
      margin-top: 0 !important;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after {
      color: #fff;
      font-size: 0.475rem;
      font-weight: bold;
    }

    .swiper-button-next {
      top: 50%;
      transform: translate(0, -50%);
      width: 0.75rem;
      height: 1.875rem;
      background: #D2D2D2;
      border-radius: 0.0375rem;
      margin-top: 0 !important;
    }

    .swiper-pagination {
      position: absolute;
      left: 8.3875rem;
      bottom: 0.4625rem;
    }

    /deep/ .swiper-pagination-bullet {
      width: 0.575rem !important;
      height: 0.05rem !important;
      background: #E5E5E5;
      border-radius: 0;
      opacity: 1;
      margin-right: 0.275rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #2498FC;
    }

    .swiper-slide.edu-slide {
      width: 15rem;
      height: 3.75rem;
      background: #FFFFFF;
      box-shadow: 0.0125rem 0.0625rem 0.1875rem 0px rgba(0, 0, 0, 0.05);
      border-radius: 0.075rem;
    }
  }

  .swiperLink {
    margin: 0 auto;
    margin-top: 0.9625rem;
    margin-bottom: 0.5rem;
    padding-top: 0.1rem;
    width: 100vw;
    padding: 0 3rem;
    height: 2.75rem;
    box-sizing: border-box;
    overflow: hidden
  }

  .xnkjg {
    width: 18rem;
    height: 5.175rem;
    margin: 0 auto;
    position: relative
  }

  .xnkjg1 {
    width: 18rem;
    height: 5.175rem;
    position: absolute;
    top: 0;
    left: 0
  }

  .xnkjg2 {
    position: absolute;
    bottom: 0.7rem !important;
    left: 0 !important;
  }

  .xnkjg2 .el-button {
    font-size: 0.24rem;
  }

  .scrollContent16 .el-button {
    font-size: 0.24rem;
  }

  .hyzyz1txt {
    flex: 1;
    margin-top: 0.8rem;
    margin-left: 2.5rem;
  }

  .hyzyz1txt1 {
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #864F16;
    line-height: 0.5rem;
  }

  .hyzyz1txt11 {
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #864F16;
    line-height: 0.375rem;
  }

  .hyzyz1txt2 {
    flex: 0 0 2.5rem
  }

  .hyzyz1txt21 {
    width: 1.675rem;
    margin-top: 1.55rem;
    height: 0.525rem;
    border: 0.025rem solid #CC6636;
    border-radius: 0.05rem;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #CC6636;
    text-align: center;
    line-height: 0.525rem;
  }

  .hyzyz {
    width: 18rem;
    height: 100%;
    padding: 0.625rem 0rem;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .hyzyz1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .hyzyz11 {
    flex: 0 0 8.525rem;
    width: 8.525rem;
    height: 2.45rem;
  }

  .hyzyz1img {
    width: 8.525rem;
    height: 2.45rem;
  }

  .news-img5 {
    width: 100%;
    height: 5.65rem
  }

  .eduSty11 {
    padding: 1rem 0 0.375rem 0;
    box-sizing: border-box;
    border-bottom: 1px solid #3C7CFF;
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #222222;
  }

  .eduSty12 {
    display: flex;
    width: 100%;
    height: calc(100% - 150px)
  }

  .eduSty13 {
    flex: 0 0 7.5rem;
    width: 7.5rem;
    margin-top: 1rem;
  }

  .eduSty14 {
    width: 100%;
    margin-bottom: 0.6rem;
    font-size: 0.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8A8888;
    line-height: 0.5rem;
  }

  .eduSty15 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.3rem
  }

  .eduSty16 {
    position: absolute;
    right: 0;
    top: 1.125rem;
    width: 1.0125rem;
    height: 4.95rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
  }

  .eduSty17 {
    position: absolute;
    right: 0.15rem;
    top: 0.8375rem;
    width: 0.9875rem;
    height: 5.5rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
  }

  .carousel5 {
    position: absolute;
    bottom: -1rem;
    width: 100%;
    z-index: 5000;
  }

  /deep/ .el-carousel__container {
    height: 100% !important
  }

  .eduSty18 /deep/ .el-carousel__container {
    height: 5.65rem !important
  }

  .eduSty18 {
    position: absolute;
    right: 0.3rem;
    top: 0.7625rem;
    width: 10rem;
    height: calc(100% - 0.7625rem);

    .el-carousel__item {
      height: 5.65rem
    }

    .el-carousel--horizontal {
      position: relative;
      height: 100%
    }

    .el-button {
      width: 0.75rem;
      height: 0.45rem;
      background: #3C7CFF;
      border-radius: 0.225rem;
      font-size: 0.225rem;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: 400;
      padding: 0;
      cursor: pointer !important;
      color: #FFFFFF;
      line-height: 0.45rem;
      box-sizing: border-box;
      border: none;
    }

    .el-button:active {
      box-shadow: inset 0px 0px 2px 2px #214fad;
    }

    .el-carousel__indicators--outside {
      left: 0 !important;
      margin-left: 0.8rem;
    }

    .el-carousel__indicator--horizontal button {
      width: 0.4rem;
      height: 0.1rem;
      background: #FCE2DE;
      opacity: 0.7;
    }

    .el-carousel__indicator--horizontal.is-active button {
      background: #3C7CFF !important;
      opacity: 1;
    }
  }

  .eduSty {
    width: 100%;
    height: 10.2rem;
    background-image: url(./image/jybj.png);
  }

  .eduSty1 {
    width: 18rem;
    height: 100%;
    margin: 0 auto;
    // padding: 0 2.6875rem 0 2.9875rem;
    box-sizing: border-box;
  }

  .scrollContent1 {
    // padding:0.975rem 9.0875rem 0 3rem;width: 100%;box-sizing: border-box;

    height: 20.425rem;
    width: 100%;
    margin: 0 auto;
    position: relative;
    padding: 0.975rem 3rem 0 3rem;
    box-sizing: border-box;
  }

  .scrollContent11 {
    font-size: 0.45rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .scrollContent12 {
    margin-top: 0.4875rem;
    margin-bottom: 1rem;
    font-size: 0.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .scrollContent13 {
    font-size: 0.45rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .scrollContent14 {
    margin-top: 0.4875rem;
    margin-bottom: 1rem;
    font-size: 0.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .scrollContent151 {
    flex: 0 0 5.75rem;
  }

  .scrollContent152 {
    width: 5.75rem;
    height: 8.625rem;
    margin-right: 0.375rem;
  }

  .scrollContent153 {
    text-align: center;
    font-size: 0.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .scrollContent16 {
    display: flex;
    width: 100%;
    text-align: center;
    justify-content: center;
    margin-top: 2rem;

    .el-button {
      background: #2498FC;
      width: 3.125rem;
      text-align: center;
      height: 0.825rem;
      color: #fff;
      padding: 0;
      border: none;
    }

    .el-button:active {
      box-shadow: inset 0px 0px 2px 2px #165f9f;
    }
  }

  .scrollContent {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-image: url(./image/cinema.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 0.825rem;
  }

  .news-img3 {
    width: 17.25rem;
    height: 100%;
  }

  .newsleftCarousel {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 1.575rem;
    background: rgba(0, 0, 0, .0.2);
    border-radius: 0px 0px 8px 8px;

    .carouselRight1 {
      margin-bottom: 0.25rem;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 0.225rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #222222;
    }

    .carouselRight2 {
      font-size: 0.2rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #222222;
      line-height: 0.375rem;
    }

    .carouselRight3 {
      font-size: 0.225rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #777777;
    }
  }

  .newsleftCarousel1 {
    width: 17.25rem;
    position: absolute;
    bottom: 0;
    height: 1.575rem;
    background: rgba(0, 0, 0, .2);
    border-radius: 0px 0px 0.1rem 0.1rem;
    padding: 0.25rem 1.125rem;
    box-sizing: border-box;

    .carouselRight1 {
      margin-bottom: 0.1875rem;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 0.225rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #222222;
    }

    .carouselRight2 {
      margin-bottom: 0.1875rem;
      font-size: 0.2rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #222222;
    }

    .carouselRight3 {
      font-size: 0.225rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #777777;
    }

    .carouselRight4t {
      display: flex;
    }
  }

  .mainContent41 {
    position: absolute;
    top: 0.825rem;
    width: 18rem;
    height: 6.875rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
  }

  .mainContent42 {
    position: absolute;
    top: 0.4125rem;
    left: 0.1875rem;
    width: 17.625rem;
    height: 7.7rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
  }

  .mainContent43 {
    position: absolute;
    top: 0;
    left: 0.375rem;
    width: 17.725rem;
    height: 8.525rem;

    background:red img {
      width: 17.25rem;
    }
  }

  .dateSty::after {
    content: '';
    /*CSS伪类用法*/
    position: absolute;
    /*定位背景横线的位置*/
    top: 52%;
    // background: #E1CED0;
    /*宽和高做出来的背景横线*/
    width: 6.9rem;
    height: 1px;
  }

  .carouselleft1 {
    width: 1rem;
    height: 4.5rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
    margin-top: 0.5rem;
  }

  .mainContent3 {
    .el-carousel--horizontal {
      position: relative;
      height: 100%;
      width: 17.25rem;
    }

    .carouselleft3 .el-carousel.el-carousel--horizontal {
      width: 9.7875rem;
    }

    .carouselright3t .el-carousel.el-carousel--horizontal {
      width: 8.15rem;
    }

    .el-button {
      width: 0.75rem;
      height: 0.45rem;
      background: #3C7CFF;
      border-radius: 0.225rem;
      font-size: 0.225rem;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: 400;
      padding: 0;
      cursor: pointer !important;
      color: #FFFFFF;
      line-height: 0.45rem;
      border: none;
    }

    .el-button:active {
      box-shadow: inset 0px 0px 2px 2px #214fad;
    }

    .el-carousel__indicators--outside {
      left: 0 !important;
      margin-left: 1.35rem;
    }

    .el-carousel__indicator--horizontal button {
      width: 0.35rem;
      height: 0.35rem;
      background: #DEDFFD !important;
      border-radius: 50%;
      font-size: 0.225rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #222222 !important;
      line-height: 0.35rem;
      opacity: 1;
      margin-right: 0.375rem;
      border: none;
    }

    .el-carousel__indicator--horizontal.is-active button {
      background: #5C5DF6 !important;
      color: #fff !important;
    }
  }

  .carouselleft2 {
    width: 1rem;
    height: 5rem;
    margin-left: -0.875rem;
    margin-top: 0.25rem;
    background: #000000;
    opacity: 0.06;
    border-radius: 0.1rem;
  }

  .news-img1 {
    width: 9.7875rem;
    height: 5.525rem;
  }

  .carouselRight31 {
    position: absolute;
    width: 100%;
    bottom: 0.7rem
  }

  .carouselRight4 {
    display: flex;
    position: absolute;
    bottom: 0.25rem;
    width: 100%;
  }

  .carouselRight41 {
    display: flex;
    align-items: center;
    flex: 1;
    line-height: 0.2rem;
  }

  .carouselRight42 {
    display: flex;
    align-items: center;
    flex: 1;
    line-height: 0.2rem;
    align-items: right;
  }

  .carouselRight422 {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.125rem;
  }

  .carouselRight421 {
    width: 0.275rem;
    height: 0.2rem;
    margin-right: 0.125rem;
  }

  .news-img2 {
    width: 8.15rem;
    height: 3.75rem;
    background: #F0F0F0;
    position: relative;
    padding: 0.6125rem 0.4875rem 0 0.4875rem;
    box-sizing: border-box;
  }

  .mainContent {
    width: 18rem;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .mainright1 {
    margin-top: 1.25rem;
    margin-left: 0.5rem;
    font-size: 0.5rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .mainright2 {
    margin-top: 0.25rem;
    margin-left: 0.5rem;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .mainright3 {
    position: absolute;
    left: 0.5rem;
    bottom: 0.5rem;
    width: 1.675rem;
    height: 0.3375rem;
  }

  .mainleft1 {
    width: 1.625rem;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    background: rgba(255, 255, 255, .1);
    border-radius: 0.075rem;
    font-size: 0.275rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .mainleft2 {
    display: flex;
    padding: 0.2625rem 0 0.375rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, .5)
  }

  .mainleft21 {
    flex: 0 0 3.25rem;
    position: relative;
  }

  .mainleft21::after {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-50%, -50%);
    content: "";
    display: inline-block;
    width: 1px;
    height: 0.475rem;
    background: #FE4066;
  }

  .mainleft211 {
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .mainleft212 {
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .mainleft221 {
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .mainleft222 {
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
  }

  .mainleft3 {
    margin-top: 0.275rem;
    margin-bottom: 0.1875rem;
  }

  .mainleft31 {
    height: 0.5rem;
    padding: 0.1125rem 0.1375rem;
    background: rgba(255, 255, 255, .1);
    border-radius: 0.075rem;
    font-size: 0.275rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .mainleft32 {
    width: 100%;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
    margin-bottom: 0.375rem;
  }

  .mainleft4 {
    margin: 0.275rem 0 0.25rem 0;
  }

  .mainleft41 {
    height: 0.5rem;
    padding: 0.1125rem 0.1375rem;
    background: rgba(255, 255, 255, .1);
    border-radius: 0.075rem;
    font-size: 0.275rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .mainleft5 {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .mainContent2 {
    width: 100%;
    min-height: 6.5rem;
    display: flex;
  }

  .mainContent21 {
    width: 13.25rem;
    flex: 0 0 13.25rem;
    min-height: 6.5rem;
    background: #5C5DF6;
    border-radius: 0.05rem;
  }

  .mainContent22 {
    width: 4.5rem;
    flex: 0 0 4.5rem;
    // height: 6.5rem;
    background-image: url('./image/ticketbg.gif');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    margin-left: 0.25rem;
  }

  .mainContent1 {
    width: 100%;
    height: 3.25rem;
    display: flex;
  }

  .mainContent11 {
    cursor: pointer;
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mainContentInner1 {
    width: 0.5rem;
    height: 0.5rem;
    margin-top: 1rem;
  }

  .mainContentInner2 {
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #222222;
    margin-top: 0.375rem;
    height: 0.4125rem;
    // margin-bottom: 0.1875rem;
  }

  .mainContentInner2:hover {
    font-size: 0.25rem
  }

  .mainContent11:nth-child(2) .mainContentInner1 {
    width: 0.625rem;
    height: 0.5rem;
  }

  .mainContentInner3 {
    font-size: 0.175rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
  }

  .textSty {
    margin-right: 0.1875rem;
  }

  .textSty::before {
    content: "";
    display: inline-block;
    width: 0.125rem;
    height: 0.125rem;
    background: #3C7CFF;
    border-radius: 50%;
    margin-right: 0.0875rem;
  }

  .wrapNotice {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .wrapNotice .tip {
    font-weight: 700;
    font-size: 0.2rem;
  }

  .wrapNotice .content {
    flex: 1;
    height: 100%;
    line-height: 0.625rem;
    font-size: 0.2rem;
    overflow: hidden;
  }

  .wrapNotice .content .text {
    padding-left: 100%;
    padding-right: 100%;
    white-space: nowrap;
  }

  .contactImg {
    position: relative;
    width: 100%;
    height: 9.75rem;

    .contactImg1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 9.75rem;

      img {
        width: 100%;
        height: 9.75rem;
      }

      /deep/ .el-carousel__indicators--outside {
        // transform: translate(-50%, 0px);
        bottom: 1rem !important;
      }

      /deep/ .el-carousel__arrow {
        font-size: 0.625rem;
        width: 0.875rem !important;
        height: 0.875rem !important;
      }

      .el-carousel__indicators--horizontal {
        padding-top: 0;
        padding-top: 0;
        bottom: 0.625rem !important;
      }

      /deep/ .el-carousel--horizontal {
        height: 9.75rem;

        /deep/ .el-carousel__indicators--horizontal {
          padding-top: 0;
          padding-top: 0;
          bottom: 0.625rem !important;
        }

        .el-carousel__indicator--horizontal button {
          width: 0.175rem;
          height: 0.175rem;
          background: #FFFFFF;
          border-radius: 50%;
          opacity: 0.5;

        }

        .el-carousel__indicator--horizontal.is-active button {
          opacity: 1;
        }
      }
    }

    .contactImg2 {
      position: absolute;
      bottom: 0;
      left: 0%;
      width: 100%;
      margin: 0 auto;
      font-size: 0.9875rem;
      z-index: 1000;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      box-sizing: border-box;
    }

    .contactTxt1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 1.7rem 0 0 0;
      font-size: 1.6375rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;

      .txt2 {
        font-size: 0.675rem
      }
    }
  }

  .noticeSty {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 0 0.5rem;
    box-sizing: border-box;
  }

  .noticeSty1 {
    flex: 1;

    #box {
      width: 100%;
      height: 0.625rem;
      position: relative;
      font-size: 0.4rem;
    }

    .marquee-box {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: auto;
    }

    #pWidth {
      width: 100%;
      height: 0.625rem;
      padding: 0;
      margin: 0;
      line-height: 0.625rem;
      display: block;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      font-family: 微软雅黑;
      fontSize: 14px;
    }

    ::-webkit-scrollbar {
      width: 0 !important;
    }

    ::-webkit-scrollbar {
      width: 0 !important;
      height: 0;
    }
  }

  .noticeSty2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 0.75rem;

    img {
      width: 0.3875rem !important;
      height: 0.25rem !important;
    }
  }

  .noticeSty2:before {
    position: absolute;
    left: 0;
    height: calc(100% - 0.3rem);
    width: 1px;
    background: #fff;
    content: '';
  }

  .carousel4 {
    width: 100% !important;
    height: 1.575rem;
    color: #fff;
    border-radius: 0px 0px 8px 8px;

    .el-carousel__indicators--horizontal {
      position: absolute;
      width: 0.475rem;
      height: 0.475rem;
    }

    .el-carousel__indicator {
      width: 0.475rem;
      height: 0.475rem;
      padding-left: 0;
      padding-right: 0;
    }

    .el-carousel__indicator--horizontal button {
      width: 0.475rem;
      height: 0.475rem;
      background: #fff !important;
      border-radius: 0;
      color: #C43040 !important;
      font-size: 0.3rem;
    }

    .el-carousel__indicator--horizontal.is-active button {
      background: #C43040 !important;
      color: #fff !important;
      border-radius: 0;
      font-size: 0.3rem;
    }
  }

  .teamSty {
    text-align: left;
    min-height: 100%;
    // overflow: auto;
    // margin:0 auto;
    // box-sizing: border-box;
  }

  .teamTitle {
    text-align: center;
    font-size: 0.35rem;
    font-weight: bold;
    color: #333333;
    margin-top: 0.7rem;
    margin-bottom: 0.4625rem;
  }

  .teamTitle1 {
    font-size: 0.225rem;
    font-weight: bold;
    line-height: 0.6rem;
    color: #333333;
  }

  .teamContent {
    font-size: 0.225rem;
    color: #333333;
    line-height: 0.5rem;
  }

  .butselfSty.el-form-item {
    width: 100% !important;
  }

  .butselfSty.el-form-item /deep/ .el-form-item__content {
    width: 100% !important;
    justify-content: center;
  }

  .tdtime /deep/ .el-input {
    width: 2.8375rem;
    height: 0.75rem;
    line-height: 0.75rem;
    border: 0.025rem solid #E5E5E5;
    border-radius: 0.0625rem;
  }

  .tdtime .el-date-editor {
    padding: 0 30px !important;
  }

  .tdtime .el-date-editor /deep/ .el-input__inner {
    background-color: transparent;
  }

  .sxrySty {
    /deep/ .el-input-number__increase {
      width: 0;
      border: none !important;

      .el-icon-arrow-up:before {
        font-size: 0;
      }
    }

    /deep/ .el-input-number__decrease {
      width: 0;
      border: none !important;

      .el-icon-arrow-down:before {
        font-size: 0;
      }
    }

    /deep/ .el-input-number__increase1 {
      cursor: pointer;
      position: absolute;
      top: 30% !important;
      right: 0.375rem;
      display: flex;
      z-index: 3000;
      width: 0.2125rem;
      height: 0.125rem !important;
      border-left: none !important;
      border-bottom: none !important;

      .el-icon-arrow-up {
        width: 0.2125rem;
        height: 0.125rem !important;
      }

      .el-icon-arrow-up:before {
        width: 0.2125rem;
        height: 0.125rem !important;
        background: url(../teamAppoint/image/teamUp.png) no-repeat;
        background-size: 0.2125rem 0.125rem;
        // background-position: 0% 100%;
        color: transparent;
        cursor: pointer;
        display: inline-block;
      }

    }

    /deep/ .el-input-number__decrease1 {
      cursor: pointer;
      position: absolute;
      top: 60% !important;
      right: 0.375rem;
      z-index: 3000;
      display: flex;
      border-left: none !important;
      width: 0.2125rem;
      height: 0.125rem !important;

      .el-icon-arrow-down {
        width: 0.2125rem;
        height: 0.125rem !important;
      }

      .el-icon-arrow-down:before {
        width: 0.2125rem;
        height: 0.125rem !important;
        background: url(../teamAppoint/image/teamDown.png) no-repeat;
        background-size: 0.2125rem 0.125rem;
        color: transparent;
        cursor: pointer;
        display: inline-block;
      }
    }

    /deep/ input::-webkit-outer-spin-button,
    /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: true !important;
    }

    /deep/ input[type='number'] {
      -moz-appearance: textfield !important;
    }

    .el-input-number {
      width: 5.625rem !important;
      position: relative;

      /deep/ .el-input__inner {
        text-align: left !important;
        padding-right: 0;
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index/home.vue